<template>
  <b-modal
    :title=modalTitle
    ref="compare-modal"
    id="compare-modal"
    size="lg"
    hide-footer
    @hidden="resetModal"
    no-close-on-backdrop
    centered
  >
    <!-- <b-card class="m-0" style="font-family: NanumBarunGothic;"> -->
    <section style="font-family: NanumBarunGothic;">
      <!-- 브랜드 선택 영역 -->
      <b-row>
        <b-col xl="2" md="2" sm="2">
          <vue-select
            class="select-brand"
            label="title"            
            :options="compareBrandList"
            :clearable="true"
            v-model="compareSelectedBrand1"
            placeholder="브랜드(전체)"
            style="height: 32px; width: 180px; text-align: center; font-size: 12px; font-weight: 600; margin-left: 5px;"
          >
          </vue-select>
        </b-col>
        <b-col xl="4" md="4" sm="4" style="margin-left: -8rem; margin-top: 0.1rem;">
          <flat-pickr
            class="periodpickr form-control border-2"
            style="height: 32px; width: 180px; text-align: center; font-size: 12px; font-weight: 600; margin-left: 5px;"
            placeholder="YYYY-MM ~ YYYY-MM"
            :config="configs.monthSelect" 
            :value="form1.monthSelect"
            @on-open="datePickerOnOpen1"
            @on-change="datePickerOnChange1"
            @on-close="datepickerCloseHandler1"
          />
        </b-col>
        <b-col xl="6" md="6" sm="6">
          <b-row>
            <b-col xl="2" md="2" sm="2" style="margin-left: 8rem;">
              <vue-select
                class="select-brand"
                label="title"            
                :options="compareBrandList"
                :clearable="true"
                v-model="compareSelectedBrand2"
                placeholder="브랜드(전체)"
                style="height: 32px; width: 180px; text-align: center; font-size: 12px; font-weight: 600; margin-left: 5px;"
              >
              </vue-select>
            </b-col>
            <b-col xl="4" md="4" sm="4" style="margin-left: 3rem; margin-top: 0.1rem;">
              <flat-pickr
                class="periodpickr form-control border-2"
                style="height: 32px; width: 180px; text-align: center; font-size: 12px; font-weight: 600; margin-left: 5px;"
                placeholder="YYYY-MM ~ YYYY-MM"
                :config="configs.monthSelect" 
                :value="form2.monthSelect"
                @on-open="datePickerOnOpen2"
                @on-change="datePickerOnChange2"
                @on-close="datepickerCloseHandler2"
              />
            </b-col>
            <b-col xl="6" md="6" sm="6">
              <div style="position: absolute; margin-top: 0.5rem; margin-left: 85%; display: none;">
                <b-button id="swapChart" style="height: auto; width: 40px; padding: 0.6rem 0.85rem; margin-right: 5px;" @click="swapChart">                  
                  <div style="margin-left: -0.1rem;">
                    <i class="fa-solid fa-arrow-right-arrow-left"></i>
                  </div>
                </b-button>
                <b-tooltip target="swapChart" triggers="hover"> 차트변경 </b-tooltip>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!-- 원차트 -->
      <b-row id="oneChartRow" style="display: none; padding: 1rem;">
        <b-row style="margin-top: 1rem; margin-left: -1rem;">
          <b-col id="compareCDJCol0" style="padding-left: 0.4rem;">
            <table id="compareCdjTable0" class="compareCdjTable0">
              <tr id="compareCdjTable0_1Tr" class="compareCdjTable0_1Tr">
                <th id="compareCdjTable0_1Tr_4Th" class="compareCdjTable0_1Tr_4Th" colspan="10" @click="loadInsightDataBottomTable('total', '', 'compareCdjTable0_1Tr_4Th')" style="border-bottom-width: 2px;">
                  TOTAL 
                  <span style="color: #7367f0;">
                    <b style="color: #1951DC">{{ Math.round(this.compare01_total_search_freq).toLocaleString() }}</b> / <b style="color: #13A53D">{{ Math.round(this.compare02_total_search_freq).toLocaleString() }}</b>
                  </span>
                </th>
              </tr>
              <tr id="compareCdjTable0_1Tr" class="compareCdjTable0_1Tr">
                <th id="compareCdjTable0_1Tr_1Th" class="compareCdjTable0_1Tr_1Th" colspan="3" @click="loadInsightDataBottomTable('cdj', '카테고리 탐색', 'compareCdjTable0_1Tr_1Th')" style="border-right-width: 2px;">
                  카테고리 탐색
                  <br/>
                  <div style="color: #7367f0; margin-top: -3px;">
                    <small><b style="color: #1951DC">{{ Math.round(this.compare01_general_search_freq).toLocaleString() }}</b> / <b style="color: #13A53D">{{ Math.round(this.compare02_general_search_freq).toLocaleString() }}</b></small>
                  </div>
                </th>
                <th id="compareCdjTable0_1Tr_2Th" class="compareCdjTable0_1Tr_2Th" colspan="5" @click="loadInsightDataBottomTable('cdj', '속성 탐색', 'compareCdjTable0_1Tr_2Th')" style="border-right-width: 2px;">
                  속성 탐색
                  <br/>
                  <div style="color: #7367f0; margin-top: -3px;">
                    <small><b style="color: #1951DC">{{ Math.round(this.compare01_attribute_search_freq).toLocaleString() }}</b> / <b style="color: #13A53D">{{ Math.round(this.compare02_attribute_search_freq).toLocaleString() }}</b></small>
                  </div>
                </th>
                <th id="compareCdjTable0_1Tr_3Th" class="compareCdjTable0_1Tr_3Th" colspan="2" @click="loadInsightDataBottomTable('cdj', '구매 및 관리', 'compareCdjTable0_1Tr_3Th')" style="border-right-width: 2px;">
                  구매 및 관리
                  <br/>
                  <div style="color: #7367f0; margin-top: -3px;">
                    <small><b style="color: #1951DC">{{ Math.round(this.compare01_buy_manage_freq).toLocaleString() }}</b> / <b style="color: #13A53D">{{ Math.round(this.compare02_buy_manage_freq).toLocaleString() }}</b></small>
                  </div>
                </th>
              </tr>
              <tr id="compareCdjTable0_2Tr" class="compareCdjTable0_2Tr">
                <td id="compareCdjTable0_2Tr_1Td" class="compareCdjTable0_2Tr_1Td" @click="loadInsightDataBottomTable('compareCdjDetails0', compare01_general_search_detail_1_nm, 'compareCdjTable0_2Tr_1Td')">
                  {{ this.compare01_general_search_detail_1_nm }}
                </td>
                <td id="compareCdjTable0_2Tr_2Td" class="compareCdjTable0_2Tr_2Td" @click="loadInsightDataBottomTable('compareCdjDetails0', compare01_general_search_detail_2_nm, 'compareCdjTable0_2Tr_2Td')">
                  {{ this.compare01_general_search_detail_2_nm }}
                </td>
                <td id="compareCdjTable0_2Tr_3Td" class="compareCdjTable0_2Tr_3Td" @click="loadInsightDataBottomTable('compareCdjDetails0', compare01_general_search_detail_3_nm, 'compareCdjTable0_2Tr_3Td')" style="border-right-width: 2px;">
                  {{ this.compare01_general_search_detail_3_nm }}
                </td>
                <td id="compareCdjTable0_2Tr_4Td" class="compareCdjTable0_2Tr_4Td" @click="loadInsightDataBottomTable('compareCdjDetails0', compare01_attribute_search_detail_1_nm, 'compareCdjTable0_2Tr_4Td')">
                  {{ this.compare01_attribute_search_detail_1_nm }}
                </td>
                <td id="compareCdjTable0_2Tr_5Td" class="compareCdjTable0_2Tr_5Td" @click="loadInsightDataBottomTable('compareCdjDetails0', compare01_attribute_search_detail_2_nm, 'compareCdjTable0_2Tr_5Td')">
                  {{ this.compare01_attribute_search_detail_2_nm }}
                </td>
                <td id="compareCdjTable0_2Tr_6Td" class="compareCdjTable0_2Tr_6Td" @click="loadInsightDataBottomTable('compareCdjDetails0', compare01_attribute_search_detail_3_nm, 'compareCdjTable0_2Tr_6Td')">
                  {{ this.compare01_attribute_search_detail_3_nm }}
                </td>
                <td id="compareCdjTable0_2Tr_7Td" class="compareCdjTable0_2Tr_7Td" @click="loadInsightDataBottomTable('compareCdjDetails0', compare01_attribute_search_detail_4_nm, 'compareCdjTable0_2Tr_7Td')">
                  {{ this.compare01_attribute_search_detail_4_nm }}
                </td>
                <td id="compareCdjTable0_2Tr_8Td" class="compareCdjTable0_2Tr_8Td" @click="loadInsightDataBottomTableETC('compareCdjDetails0', [compare01_attribute_search_detail_1_nm, compare01_attribute_search_detail_2_nm, compare01_attribute_search_detail_3_nm, compare01_attribute_search_detail_4_nm], '속성 탐색', 'compareCdjTable0_2Tr_8Td')" style="border-right-width: 2px;">
                  {{ this.compare01_attribute_search_detail_5_nm }}
                </td>
                <td id="compareCdjTable0_2Tr_9Td" class="compareCdjTable0_2Tr_9Td" @click="loadInsightDataBottomTable('compareCdjDetails0', compare01_buy_manage_detail_1_nm, 'compareCdjTable0_2Tr_9Td')">
                  {{ this.compare01_buy_manage_detail_1_nm }}
                </td>
                <td id="compareCdjTable0_2Tr_10Td" class="compareCdjTable0_2Tr_10Td" @click="loadInsightDataBottomTable('compareCdjDetails0', compare01_buy_manage_detail_2_nm, 'compareCdjTable0_2Tr_10Td')" style="border-right-width: 2px;">
                  {{ this.compare01_buy_manage_detail_2_nm }}
                </td>
              </tr>
              <tr id="compareCdjTable0_3Tr" class="compareCdjTable0_3Tr">
                <td id="compareCdjTable0_3Tr_1Td" class="compareCdjTable0_3Tr_1Td" @click="loadInsightDataBottomTable('compareCdjDetails0', compare01_general_search_detail_1_nm, 'compareCdjTable0_3Tr_1Td')">
                  {{ this.compare01_general_search_detail_1_rate }} / {{ this.compare02_general_search_detail_1_rate }}
                </td>
                <b-tooltip target="compareCdjTable0_3Tr_1Td" triggers="hover"> {{ Math.round(this.compare01_general_search_detail_1_freq).toLocaleString() }} </b-tooltip>
                <td id="compareCdjTable0_3Tr_2Td" class="compareCdjTable0_3Tr_2Td" @click="loadInsightDataBottomTable('compareCdjDetails0', compare01_general_search_detail_2_nm, 'compareCdjTable0_3Tr_2Td')">
                  {{ this.compare01_general_search_detail_2_rate }} / {{ this.compare02_general_search_detail_2_rate }}
                </td>
                <b-tooltip target="compareCdjTable0_3Tr_2Td" triggers="hover"> {{ Math.round(this.compare01_general_search_detail_2_freq).toLocaleString() }} </b-tooltip>
                <td id="compareCdjTable0_3Tr_3Td" class="compareCdjTable0_3Tr_3Td" @click="loadInsightDataBottomTable('compareCdjDetails0', compare01_general_search_detail_3_nm, 'compareCdjTable0_3Tr_3Td')" style="border-right-width: 2px;">
                  {{ this.compare01_general_search_detail_3_rate }} / {{ this.compare02_general_search_detail_3_rate }}
                </td>
                <b-tooltip target="compareCdjTable0_3Tr_3Td" triggers="hover"> {{ Math.round(this.compare01_general_search_detail_3_freq).toLocaleString() }} </b-tooltip>
                <td id="compareCdjTable0_3Tr_4Td" class="compareCdjTable0_3Tr_4Td" @click="loadInsightDataBottomTable('compareCdjDetails0', compare01_attribute_search_detail_1_nm, 'compareCdjTable0_3Tr_4Td')">
                  {{ this.compare01_attribute_search_detail_1_rate }} / {{ this.compare02_attribute_search_detail_1_rate }}
                </td>
                <b-tooltip target="compareCdjTable0_3Tr_4Td" triggers="hover"> {{ Math.round(this.compare01_attribute_search_detail_1_freq).toLocaleString() }} </b-tooltip>
                <td id="compareCdjTable0_3Tr_5Td" class="compareCdjTable0_3Tr_5Td" @click="loadInsightDataBottomTable('compareCdjDetails0', compare01_attribute_search_detail_2_nm, 'compareCdjTable0_3Tr_5Td')">
                  {{ this.compare01_attribute_search_detail_2_rate }} / {{ this.compare02_attribute_search_detail_2_rate }}
                </td>
                <b-tooltip target="compareCdjTable0_3Tr_5Td" triggers="hover"> {{ Math.round(this.compare01_attribute_search_detail_2_freq).toLocaleString() }} </b-tooltip>
                <td id="compareCdjTable0_3Tr_6Td" class="compareCdjTable0_3Tr_6Td" @click="loadInsightDataBottomTable('compareCdjDetails0', compare01_attribute_search_detail_3_nm, 'compareCdjTable0_3Tr_6Td')">
                  {{ this.compare01_attribute_search_detail_3_rate }} / {{ this.compare02_attribute_search_detail_3_rate }}
                </td>
                <b-tooltip target="compareCdjTable0_3Tr_6Td" triggers="hover"> {{ Math.round(this.compare01_attribute_search_detail_3_freq).toLocaleString() }} </b-tooltip>
                <td id="compareCdjTable0_3Tr_7Td" class="compareCdjTable0_3Tr_7Td" @click="loadInsightDataBottomTable('compareCdjDetails0', compare01_attribute_search_detail_4_nm, 'compareCdjTable0_3Tr_7Td')">
                  {{ this.compare01_attribute_search_detail_4_rate }} / {{ this.compare02_attribute_search_detail_4_rate }}
                </td>
                <b-tooltip target="compareCdjTable0_3Tr_7Td" triggers="hover"> {{ Math.round(this.compare01_attribute_search_detail_4_freq).toLocaleString() }} </b-tooltip>
                <td id="compareCdjTable0_3Tr_8Td" class="compareCdjTable0_3Tr_8Td" @click="loadInsightDataBottomTableETC('compareCdjDetails0', [compare01_attribute_search_detail_1_nm, compare01_attribute_search_detail_2_nm, compare01_attribute_search_detail_3_nm, compare01_attribute_search_detail_4_nm], '속성 탐색', 'compareCdjTable0_3Tr_8Td')" style="border-right-width: 2px;">
                  {{ this.compare01_attribute_search_detail_5_rate }} / {{ this.compare02_attribute_search_detail_5_rate }}
                </td>
                <b-tooltip target="compareCdjTable0_3Tr_8Td" triggers="hover"> {{ Math.round(this.compare01_attribute_search_detail_5_freq).toLocaleString() }} </b-tooltip>
                <td id="compareCdjTable0_3Tr_9Td" class="compareCdjTable0_3Tr_9Td" @click="loadInsightDataBottomTable('compareCdjDetails0', compare01_buy_manage_detail_1_nm, 'compareCdjTable0_3Tr_9Td')">
                  {{ this.compare01_buy_manage_detail_1_rate }} / {{ this.compare02_buy_manage_detail_1_rate }}
                </td>
                <b-tooltip target="compareCdjTable0_3Tr_9Td" triggers="hover"> {{ Math.round(this.compare01_buy_manage_detail_1_freq).toLocaleString() }} </b-tooltip>
                <td id="compareCdjTable0_3Tr_10Td" class="compareCdjTable0_3Tr_10Td" @click="loadInsightDataBottomTable('compareCdjDetails0', compare01_buy_manage_detail_2_nm, 'compareCdjTable0_3Tr_10Td')" style="border-right-width: 2px;">
                  {{ this.compare01_buy_manage_detail_2_rate }} / {{ this.compare02_buy_manage_detail_2_rate }}
                </td>
                <b-tooltip target="compareCdjTable0_3Tr_10Td" triggers="hover"> {{ Math.round(this.compare01_buy_manage_detail_2_freq).toLocaleString() }} / {{ Math.round(this.compare02_buy_manage_detail_2_freq).toLocaleString() }} </b-tooltip>
              </tr>
            </table>
            <div style="position: relative; min-height: 500px;">
              <div id="compareLoadingStack0" class="text-center text-primary my-2" style="position: absolute; top: 40%; left: 45%; visibility: visible;">
                <b-spinner class="align-middle mr-2"></b-spinner>
                <strong>분석중...</strong>
              </div>
              <div class="graphic-container2" id="compareStackChart0" style="visibility: hidden;">
                <compare-chart-stack-merge
                  :compareStackChartData="compareStackChartData0"
                  :compareStackChartCategory="compareStackChartCategory0"
                />
              </div>  
            </div>

          </b-col>
        </b-row>
      </b-row>
      <!-- 투차트 -->
      <b-row id="twoChartRow" style="display: flex;">
        <!-- 첫번째 차트 영역 -->
        <b-col xl="6" md="6" sm="6"> 
          <b-row style="margin-top: 1rem; margin-left: -1rem;">
            <b-col id="compareCDJCol1" style="padding-left: 0.4rem;">
              <table id="compareCdjTable1" class="compareCdjTable1">
                <tr id="compareCdjTable1_1Tr" class="compareCdjTable1_1Tr">
                  <th id="compareCdjTable1_1Tr_4Th" class="compareCdjTable1_1Tr_4Th" colspan="10" @click="loadInsightDataBottomTable('total', '', 'compareCdjTable1_1Tr_4Th')" style="border-bottom-width: 2px;">
                    TOTAL 
                    <span style="color: #1951DC;">
                      <b>{{ Math.round(this.compare1_total_search_freq).toLocaleString() }}</b>
                    </span>
                  </th>
                </tr>
                <tr id="compareCdjTable1_1Tr" class="compareCdjTable1_1Tr">
                  <th id="compareCdjTable1_1Tr_1Th" class="compareCdjTable1_1Tr_1Th" colspan="3" @click="loadInsightDataBottomTable('cdj', '카테고리 탐색', 'compareCdjTable1_1Tr_1Th')" style="border-right-width: 2px;">
                    카테고리 탐색
                    <br/>
                    <div style="color: #1951DC; margin-top: -3px;">
                      <small><b>{{ Math.round(this.compare1_general_search_freq).toLocaleString() }} ({{ this.compare1_general_search_rate }})</b></small>
                    </div>
                  </th>
                  <th id="compareCdjTable1_1Tr_2Th" class="compareCdjTable1_1Tr_2Th" colspan="5" @click="loadInsightDataBottomTable('cdj', '속성 탐색', 'compareCdjTable1_1Tr_2Th')" style="border-right-width: 2px;">
                    속성 탐색
                    <br/>
                    <div style="color: #1951DC; margin-top: -3px;">
                      <small><b>{{ Math.round(this.compare1_attribute_search_freq).toLocaleString() }} ({{ this.compare1_attribute_search_rate }})</b></small>
                    </div>
                  </th>
                  <th id="compareCdjTable1_1Tr_3Th" class="compareCdjTable1_1Tr_3Th" colspan="2" @click="loadInsightDataBottomTable('cdj', '구매 및 관리', 'compareCdjTable1_1Tr_3Th')" style="border-right-width: 2px;">
                    구매 및 관리
                    <br/>
                    <div style="color: #1951DC; margin-top: -3px;">
                      <small><b>{{ Math.round(this.compare1_buy_manage_freq).toLocaleString() }} ({{ this.compare1_buy_manage_rate }})</b></small>
                    </div>
                  </th>
                </tr>
                <tr id="compareCdjTable1_2Tr" class="compareCdjTable1_2Tr">
                  <td id="compareCdjTable1_2Tr_1Td" class="compareCdjTable1_2Tr_1Td" @click="loadInsightDataBottomTable('compareCdjDetails1', compare1_general_search_detail_1_nm, 'compareCdjTable1_2Tr_1Td')">
                    {{ this.compare1_general_search_detail_1_nm }}
                  </td>
                  <td id="compareCdjTable1_2Tr_2Td" class="compareCdjTable1_2Tr_2Td" @click="loadInsightDataBottomTable('compareCdjDetails1', compare1_general_search_detail_2_nm, 'compareCdjTable1_2Tr_2Td')">
                    {{ this.compare1_general_search_detail_2_nm }}
                  </td>
                  <td id="compareCdjTable1_2Tr_3Td" class="compareCdjTable1_2Tr_3Td" @click="loadInsightDataBottomTable('compareCdjDetails1', compare1_general_search_detail_3_nm, 'compareCdjTable1_2Tr_3Td')" style="border-right-width: 2px;">
                    {{ this.compare1_general_search_detail_3_nm }}
                  </td>
                  <td id="compareCdjTable1_2Tr_4Td" class="compareCdjTable1_2Tr_4Td" @click="loadInsightDataBottomTable('compareCdjDetails1', compare1_attribute_search_detail_1_nm, 'compareCdjTable1_2Tr_4Td')">
                    {{ this.compare1_attribute_search_detail_1_nm }}
                  </td>
                  <td id="compareCdjTable1_2Tr_5Td" class="compareCdjTable1_2Tr_5Td" @click="loadInsightDataBottomTable('compareCdjDetails1', compare1_attribute_search_detail_2_nm, 'compareCdjTable1_2Tr_5Td')">
                    {{ this.compare1_attribute_search_detail_2_nm }}
                  </td>
                  <td id="compareCdjTable1_2Tr_6Td" class="compareCdjTable1_2Tr_6Td" @click="loadInsightDataBottomTable('compareCdjDetails1', compare1_attribute_search_detail_3_nm, 'compareCdjTable1_2Tr_6Td')">
                    {{ this.compare1_attribute_search_detail_3_nm }}
                  </td>
                  <td id="compareCdjTable1_2Tr_7Td" class="compareCdjTable1_2Tr_7Td" @click="loadInsightDataBottomTable('compareCdjDetails1', compare1_attribute_search_detail_4_nm, 'compareCdjTable1_2Tr_7Td')">
                    {{ this.compare1_attribute_search_detail_4_nm }}
                  </td>
                  <td id="compareCdjTable1_2Tr_8Td" class="compareCdjTable1_2Tr_8Td" @click="loadInsightDataBottomTableETC('compareCdjDetails1', [compare1_attribute_search_detail_1_nm, compare1_attribute_search_detail_2_nm, compare1_attribute_search_detail_3_nm, compare1_attribute_search_detail_4_nm], '속성 탐색', 'compareCdjTable1_2Tr_8Td')" style="border-right-width: 2px;">
                    {{ this.compare1_attribute_search_detail_5_nm }}
                  </td>
                  <td id="compareCdjTable1_2Tr_9Td" class="compareCdjTable1_2Tr_9Td" @click="loadInsightDataBottomTable('compareCdjDetails1', compare1_buy_manage_detail_1_nm, 'compareCdjTable1_2Tr_9Td')">
                    {{ this.compare1_buy_manage_detail_1_nm }}
                  </td>
                  <td id="compareCdjTable1_2Tr_10Td" class="compareCdjTable1_2Tr_10Td" @click="loadInsightDataBottomTable('compareCdjDetails1', compare1_buy_manage_detail_2_nm, 'compareCdjTable1_2Tr_10Td')" style="border-right-width: 2px;">
                    {{ this.compare1_buy_manage_detail_2_nm }}
                  </td>
                </tr>
                <tr id="compareCdjTable1_3Tr" class="compareCdjTable1_3Tr">
                  <td id="compareCdjTable1_3Tr_1Td" class="compareCdjTable1_3Tr_1Td" @click="loadInsightDataBottomTable('compareCdjDetails1', compare1_general_search_detail_1_nm, 'compareCdjTable1_3Tr_1Td')">
                    {{ this.compare1_general_search_detail_1_rate }}
                  </td>
                  <b-tooltip target="compareCdjTable1_3Tr_1Td" triggers="hover"> {{ Math.round(this.compare1_general_search_detail_1_freq).toLocaleString() }} </b-tooltip>
                  <td id="compareCdjTable1_3Tr_2Td" class="compareCdjTable1_3Tr_2Td" @click="loadInsightDataBottomTable('compareCdjDetails1', compare1_general_search_detail_2_nm, 'compareCdjTable1_3Tr_2Td')">
                    {{ this.compare1_general_search_detail_2_rate }}
                  </td>
                  <b-tooltip target="compareCdjTable1_3Tr_2Td" triggers="hover"> {{ Math.round(this.compare1_general_search_detail_2_freq).toLocaleString() }} </b-tooltip>
                  <td id="compareCdjTable1_3Tr_3Td" class="compareCdjTable1_3Tr_3Td" @click="loadInsightDataBottomTable('compareCdjDetails1', compare1_general_search_detail_3_nm, 'compareCdjTable1_3Tr_3Td')" style="border-right-width: 2px;">
                    {{ this.compare1_general_search_detail_3_rate }}
                  </td>
                  <b-tooltip target="compareCdjTable1_3Tr_3Td" triggers="hover"> {{ Math.round(this.compare1_general_search_detail_3_freq).toLocaleString() }} </b-tooltip>
                  <td id="compareCdjTable1_3Tr_4Td" class="compareCdjTable1_3Tr_4Td" @click="loadInsightDataBottomTable('compareCdjDetails1', compare1_attribute_search_detail_1_nm, 'compareCdjTable1_3Tr_4Td')">
                    {{ this.compare1_attribute_search_detail_1_rate }}
                  </td>
                  <b-tooltip target="compareCdjTable1_3Tr_4Td" triggers="hover"> {{ Math.round(this.compare1_attribute_search_detail_1_freq).toLocaleString() }} </b-tooltip>
                  <td id="compareCdjTable1_3Tr_5Td" class="compareCdjTable1_3Tr_5Td" @click="loadInsightDataBottomTable('compareCdjDetails1', compare1_attribute_search_detail_2_nm, 'compareCdjTable1_3Tr_5Td')">
                    {{ this.compare1_attribute_search_detail_2_rate }}
                  </td>
                  <b-tooltip target="compareCdjTable1_3Tr_5Td" triggers="hover"> {{ Math.round(this.compare1_attribute_search_detail_2_freq).toLocaleString() }} </b-tooltip>
                  <td id="compareCdjTable1_3Tr_6Td" class="compareCdjTable1_3Tr_6Td" @click="loadInsightDataBottomTable('compareCdjDetails1', compare1_attribute_search_detail_3_nm, 'compareCdjTable1_3Tr_6Td')">
                    {{ this.compare1_attribute_search_detail_3_rate }}
                  </td>
                  <b-tooltip target="compareCdjTable1_3Tr_6Td" triggers="hover"> {{ Math.round(this.compare1_attribute_search_detail_3_freq).toLocaleString() }} </b-tooltip>
                  <td id="compareCdjTable1_3Tr_7Td" class="compareCdjTable1_3Tr_7Td" @click="loadInsightDataBottomTable('compareCdjDetails1', compare1_attribute_search_detail_4_nm, 'compareCdjTable1_3Tr_7Td')">
                    {{ this.compare1_attribute_search_detail_4_rate }}
                  </td>
                  <b-tooltip target="compareCdjTable1_3Tr_7Td" triggers="hover"> {{ Math.round(this.compare1_attribute_search_detail_4_freq).toLocaleString() }} </b-tooltip>
                  <td id="compareCdjTable1_3Tr_8Td" class="compareCdjTable1_3Tr_8Td" @click="loadInsightDataBottomTableETC('compareCdjDetails1', [compare1_attribute_search_detail_1_nm, compare1_attribute_search_detail_2_nm, compare1_attribute_search_detail_3_nm, compare1_attribute_search_detail_4_nm], '속성 탐색', 'compareCdjTable1_3Tr_8Td')" style="border-right-width: 2px;">
                    {{ this.compare1_attribute_search_detail_5_rate }}
                  </td>
                  <b-tooltip target="compareCdjTable1_3Tr_8Td" triggers="hover"> {{ Math.round(this.compare1_attribute_search_detail_5_freq).toLocaleString() }} </b-tooltip>
                  <td id="compareCdjTable1_3Tr_9Td" class="compareCdjTable1_3Tr_9Td" @click="loadInsightDataBottomTable('compareCdjDetails1', compare1_buy_manage_detail_1_nm, 'compareCdjTable1_3Tr_9Td')">
                    {{ this.compare1_buy_manage_detail_1_rate }}
                  </td>
                  <b-tooltip target="compareCdjTable1_3Tr_9Td" triggers="hover"> {{ Math.round(this.compare1_buy_manage_detail_1_freq).toLocaleString() }} </b-tooltip>
                  <td id="compareCdjTable1_3Tr_10Td" class="compareCdjTable1_3Tr_10Td" @click="loadInsightDataBottomTable('compareCdjDetails1', compare1_buy_manage_detail_2_nm, 'compareCdjTable1_3Tr_10Td')" style="border-right-width: 2px;">
                    {{ this.compare1_buy_manage_detail_2_rate }}
                  </td>
                  <b-tooltip target="compareCdjTable1_3Tr_10Td" triggers="hover"> {{ Math.round(this.compare1_buy_manage_detail_2_freq).toLocaleString() }} </b-tooltip>
                </tr>
              </table>
              <div style="position: relative; min-height: 500px;">
                <div id="compareLoadingStack1" class="text-center text-primary my-2" style="position: absolute; top: 40%; left: 45%; visibility: visible;">
                  <b-spinner class="align-middle mr-2"></b-spinner>
                  <strong>분석중...</strong>
                </div>
                <div class="graphic-container2" id="compareStackChart1" style="visibility: hidden;">
                  <compare-chart-stack
                    :compareStackChartData="compareStackChartData1"
                    :compareStackChartCategory="compareStackChartCategory1"
                  />
                </div>  
              </div>
            </b-col>
          </b-row>
        </b-col>
        <!-- 두번째 차트 영역 -->
        <b-col xl="6" md="6" sm="6">
          <b-row style="margin-top: 1rem; margin-left: -1rem;">
            <b-col id="compareCDJCol2" style="padding-left: 0.4rem;">
              <table id="compareCdjTable2" class="compareCdjTable2">
                <tr id="compareCdjTable2_1Tr" class="compareCdjTable2_1Tr">
                  <th id="compareCdjTable2_1Tr_4Th" class="compareCdjTable2_1Tr_4Th" colspan="10" @click="loadInsightDataBottomTable('total', '', 'compareCdjTable2_1Tr_4Th')" style="border-bottom-width: 2px;">
                    TOTAL 
                    <span style="color: #13A53D;">
                      <b>{{ Math.round(this.compare2_total_search_freq).toLocaleString() }}</b>
                    </span>
                  </th>
                </tr>
                <tr id="compareCdjTable2_1Tr" class="compareCdjTable2_1Tr">
                  <th id="compareCdjTable2_1Tr_1Th" class="compareCdjTable2_1Tr_1Th" colspan="3" @click="loadInsightDataBottomTable('cdj', '카테고리 탐색', 'compareCdjTable2_1Tr_1Th')" style="border-right-width: 2px;">
                    카테고리 탐색
                    <br/>
                    <div style="color: #13A53D; margin-top: -3px;">
                      <small><b>{{ Math.round(this.compare2_general_search_freq).toLocaleString() }} ({{ this.compare2_general_search_rate }})</b></small>
                    </div>
                  </th>
                  <th id="compareCdjTable2_1Tr_2Th" class="compareCdjTable2_1Tr_2Th" colspan="5" @click="loadInsightDataBottomTable('cdj', '속성 탐색', 'compareCdjTable2_1Tr_2Th')" style="border-right-width: 2px;">
                    속성 탐색
                    <br/>
                    <div style="color: #13A53D; margin-top: -3px;">
                      <small><b>{{ Math.round(this.compare2_attribute_search_freq).toLocaleString() }} ({{ this.compare2_attribute_search_rate }})</b></small>
                    </div>
                  </th>
                  <th id="compareCdjTable2_1Tr_3Th" class="compareCdjTable2_1Tr_3Th" colspan="2" @click="loadInsightDataBottomTable('cdj', '구매 및 관리', 'compareCdjTable2_1Tr_3Th')" style="border-right-width: 2px;">
                    구매 및 관리
                    <br/>
                    <div style="color: #13A53D; margin-top: -3px;">
                      <small><b>{{ Math.round(this.compare2_buy_manage_freq).toLocaleString() }} ({{ this.compare2_buy_manage_rate }})</b></small>
                    </div>
                  </th>
                </tr>
                <tr id="compareCdjTable2_2Tr" class="compareCdjTable2_2Tr">
                  <td id="compareCdjTable2_2Tr_1Td" class="compareCdjTable2_2Tr_1Td" @click="loadInsightDataBottomTable('compareCdjDetails2', compare2_general_search_detail_1_nm, 'compareCdjTable2_2Tr_1Td')">
                    {{ this.compare2_general_search_detail_1_nm }}
                  </td>
                  <td id="compareCdjTable2_2Tr_2Td" class="compareCdjTable2_2Tr_2Td" @click="loadInsightDataBottomTable('compareCdjDetails2', compare2_general_search_detail_2_nm, 'compareCdjTable2_2Tr_2Td')">
                    {{ this.compare2_general_search_detail_2_nm }}
                  </td>
                  <td id="compareCdjTable2_2Tr_3Td" class="compareCdjTable2_2Tr_3Td" @click="loadInsightDataBottomTable('compareCdjDetails2', compare2_general_search_detail_3_nm, 'compareCdjTable2_2Tr_3Td')" style="border-right-width: 2px;">
                    {{ this.compare2_general_search_detail_3_nm }}
                  </td>
                  <td id="compareCdjTable2_2Tr_4Td" class="compareCdjTable2_2Tr_4Td" @click="loadInsightDataBottomTable('compareCdjDetails2', compare2_attribute_search_detail_1_nm, 'compareCdjTable2_2Tr_4Td')">
                    {{ this.compare2_attribute_search_detail_1_nm }}
                  </td>
                  <td id="compareCdjTable2_2Tr_5Td" class="compareCdjTable2_2Tr_5Td" @click="loadInsightDataBottomTable('compareCdjDetails2', compare2_attribute_search_detail_2_nm, 'compareCdjTable2_2Tr_5Td')">
                    {{ this.compare2_attribute_search_detail_2_nm }}
                  </td>
                  <td id="compareCdjTable2_2Tr_6Td" class="compareCdjTable2_2Tr_6Td" @click="loadInsightDataBottomTable('compareCdjDetails2', compare2_attribute_search_detail_3_nm, 'compareCdjTable2_2Tr_6Td')">
                    {{ this.compare2_attribute_search_detail_3_nm }}
                  </td>
                  <td id="compareCdjTable2_2Tr_7Td" class="compareCdjTable2_2Tr_7Td" @click="loadInsightDataBottomTable('compareCdjDetails2', compare2_attribute_search_detail_4_nm, 'compareCdjTable2_2Tr_7Td')">
                    {{ this.compare2_attribute_search_detail_4_nm }}
                  </td>
                  <td id="compareCdjTable2_2Tr_8Td" class="compareCdjTable2_2Tr_8Td" @click="loadInsightDataBottomTableETC('compareCdjDetails2', [compare2_attribute_search_detail_1_nm, compare2_attribute_search_detail_2_nm, compare2_attribute_search_detail_3_nm, compare2_attribute_search_detail_4_nm], '속성 탐색', 'compareCdjTable2_2Tr_8Td')" style="border-right-width: 2px;">
                    {{ this.compare2_attribute_search_detail_5_nm }}
                  </td>
                  <td id="compareCdjTable2_2Tr_9Td" class="compareCdjTable2_2Tr_9Td" @click="loadInsightDataBottomTable('compareCdjDetails2', compare2_buy_manage_detail_1_nm, 'compareCdjTable2_2Tr_9Td')">
                    {{ this.compare2_buy_manage_detail_1_nm }}
                  </td>
                  <td id="compareCdjTable2_2Tr_10Td" class="compareCdjTable2_2Tr_10Td" @click="loadInsightDataBottomTable('compareCdjDetails2', compare2_buy_manage_detail_2_nm, 'compareCdjTable2_2Tr_10Td')" style="border-right-width: 2px;">
                    {{ this.compare2_buy_manage_detail_2_nm }}
                  </td>
                </tr>
                <tr id="compareCdjTable2_3Tr" class="compareCdjTable2_3Tr">
                  <td id="compareCdjTable2_3Tr_1Td" class="compareCdjTable2_3Tr_1Td" @click="loadInsightDataBottomTable('compareCdjDetails2', compare2_general_search_detail_1_nm, 'compareCdjTable2_3Tr_1Td')">
                    {{ this.compare2_general_search_detail_1_rate }}
                  </td>
                  <b-tooltip target="compareCdjTable2_3Tr_1Td" triggers="hover"> {{ Math.round(this.compare2_general_search_detail_1_freq).toLocaleString() }} </b-tooltip>
                  <td id="compareCdjTable2_3Tr_2Td" class="compareCdjTable2_3Tr_2Td" @click="loadInsightDataBottomTable('compareCdjDetails2', compare2_general_search_detail_2_nm, 'compareCdjTable2_3Tr_2Td')">
                    {{ this.compare2_general_search_detail_2_rate }}
                  </td>
                  <b-tooltip target="compareCdjTable2_3Tr_2Td" triggers="hover"> {{ Math.round(this.compare2_general_search_detail_2_freq).toLocaleString() }} </b-tooltip>
                  <td id="compareCdjTable2_3Tr_3Td" class="compareCdjTable2_3Tr_3Td" @click="loadInsightDataBottomTable('compareCdjDetails2', compare2_general_search_detail_3_nm, 'compareCdjTable2_3Tr_3Td')" style="border-right-width: 2px;">
                    {{ this.compare2_general_search_detail_3_rate }}
                  </td>
                  <b-tooltip target="compareCdjTable2_3Tr_3Td" triggers="hover"> {{ Math.round(this.compare2_general_search_detail_3_freq).toLocaleString() }} </b-tooltip>
                  <td id="compareCdjTable2_3Tr_4Td" class="compareCdjTable2_3Tr_4Td" @click="loadInsightDataBottomTable('compareCdjDetails2', compare2_attribute_search_detail_1_nm, 'compareCdjTable2_3Tr_4Td')">
                    {{ this.compare2_attribute_search_detail_1_rate }}
                  </td>
                  <b-tooltip target="compareCdjTable2_3Tr_4Td" triggers="hover"> {{ Math.round(this.compare2_attribute_search_detail_1_freq).toLocaleString() }} </b-tooltip>
                  <td id="compareCdjTable2_3Tr_5Td" class="compareCdjTable2_3Tr_5Td" @click="loadInsightDataBottomTable('compareCdjDetails2', compare2_attribute_search_detail_2_nm, 'compareCdjTable2_3Tr_5Td')">
                    {{ this.compare2_attribute_search_detail_2_rate }}
                  </td>
                  <b-tooltip target="compareCdjTable2_3Tr_5Td" triggers="hover"> {{ Math.round(this.compare2_attribute_search_detail_2_freq).toLocaleString() }} </b-tooltip>
                  <td id="compareCdjTable2_3Tr_6Td" class="compareCdjTable2_3Tr_6Td" @click="loadInsightDataBottomTable('compareCdjDetails2', compare2_attribute_search_detail_3_nm, 'compareCdjTable2_3Tr_6Td')">
                    {{ this.compare2_attribute_search_detail_3_rate }}
                  </td>
                  <b-tooltip target="compareCdjTable2_3Tr_6Td" triggers="hover"> {{ Math.round(this.compare2_attribute_search_detail_3_freq).toLocaleString() }} </b-tooltip>
                  <td id="compareCdjTable2_3Tr_7Td" class="compareCdjTable2_3Tr_7Td" @click="loadInsightDataBottomTable('compareCdjDetails2', compare2_attribute_search_detail_4_nm, 'compareCdjTable2_3Tr_7Td')">
                    {{ this.compare2_attribute_search_detail_4_rate }}
                  </td>
                  <b-tooltip target="compareCdjTable2_3Tr_7Td" triggers="hover"> {{ Math.round(this.compare2_attribute_search_detail_4_freq).toLocaleString() }} </b-tooltip>
                  <td id="compareCdjTable2_3Tr_8Td" class="compareCdjTable2_3Tr_8Td" @click="loadInsightDataBottomTableETC('compareCdjDetails2', [compare2_attribute_search_detail_1_nm, compare2_attribute_search_detail_2_nm, compare2_attribute_search_detail_3_nm, compare2_attribute_search_detail_4_nm], '속성 탐색', 'compareCdjTable2_3Tr_8Td')" style="border-right-width: 2px;">
                    {{ this.compare2_attribute_search_detail_5_rate }}
                  </td>
                  <b-tooltip target="compareCdjTable2_3Tr_8Td" triggers="hover"> {{ Math.round(this.compare2_attribute_search_detail_5_freq).toLocaleString() }} </b-tooltip>
                  <td id="compareCdjTable2_3Tr_9Td" class="compareCdjTable2_3Tr_9Td" @click="loadInsightDataBottomTable('compareCdjDetails2', compare2_buy_manage_detail_1_nm, 'compareCdjTable2_3Tr_9Td')">
                    {{ this.compare2_buy_manage_detail_1_rate }}
                  </td>
                  <b-tooltip target="compareCdjTable2_3Tr_9Td" triggers="hover"> {{ Math.round(this.compare2_buy_manage_detail_1_freq).toLocaleString() }} </b-tooltip>
                  <td id="compareCdjTable2_3Tr_10Td" class="compareCdjTable2_3Tr_10Td" @click="loadInsightDataBottomTable('compareCdjDetails2', compare2_buy_manage_detail_2_nm, 'compareCdjTable2_3Tr_10Td')" style="border-right-width: 2px;">
                    {{ this.compare2_buy_manage_detail_2_rate }}
                  </td>
                  <b-tooltip target="compareCdjTable2_3Tr_10Td" triggers="hover"> {{ Math.round(this.compare2_buy_manage_detail_2_freq).toLocaleString() }} </b-tooltip>
                </tr>
              </table>
              <div style="position: relative; min-height: 500px;">
                <div id="compareLoadingStack2" class="text-center text-primary my-2" style="position: absolute; top: 40%; left: 45%; visibility: visible;">
                  <b-spinner class="align-middle mr-2"></b-spinner>
                  <strong>분석중...</strong>
                </div>
                <div class="graphic-container2" id="compareStackChart2" style="visibility: hidden;">
                  <compare-chart-stack2
                    :compareStackChartData="compareStackChartData2"
                    :compareStackChartCategory="compareStackChartCategory2"
                  />
                </div>  
              </div>
            </b-col>
          </b-row>
          
        </b-col>
      </b-row>


    </section>
  </b-modal>
</template>

<script>
import { 
    BCard, 
    BCol, 
    BRow, 
    BCardBody, 
    BButton,
    BCardText,
    BFormRadio, 
    BFormRadioGroup,
    BTable, 
    BPagination,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BTooltip,
    BFormCheckbox,
    BFormCheckboxGroup,
} from "bootstrap-vue";

import FlatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/plugins/monthSelect/style.css'
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index.js'

import CompareChartStack from "@/views/cis-insight/components/CompareChartStack.vue";
import CompareChartStack2 from "@/views/cis-insight/components/CompareChartStack2.vue";
import CompareChartStackMerge from "@/views/cis-insight/components/CompareChartStackMerge.vue";
import moment from "moment";
import CisInsightService from "@/services/cis-insight.service";

// import CompareChartNet1 from "@/views/cis-searchtag/components/CompareChartNet1.vue";
// import CompareChartNet2 from "@/views/cis-searchtag/components/CompareChartNet2.vue";

// import CisSearchTagService from "@/services/cis-searchtag.service";

import axios from "axios"

const stringStyle = { font: { name: 'Consolas' } };
const indexNumStyle = { font: { name: 'Consolas' }, numFmt: "0" };
const intNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0" };
const intNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0;[Red]\\ \\▼#,##0;[Black]\\ \"-\"" };
const floatNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0" };
const rateNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0%" };
const rateNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0%;[Red]\\ \\▼#,##0%;[Black]\\ \"-\"" };

const boldStyle = { font: { name: 'Consolas', bold: true } };
const underlineStyle = { font: { name: 'Consolas', underline: true} };

const sleep = delay => new Promise(resolve => setTimeout(resolve, delay));

const cancelToken = axios.CancelToken;
var source = cancelToken.source();


export default {
  name: "CompareModal",
  components: {
    FlatPickr,
    BCard, 
    BCol, 
    BRow, 
    BCardBody, 
    BButton,
    BCardText,
    BFormRadio, 
    BFormRadioGroup,
    BTable, 
    BPagination,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BTooltip,
    BFormCheckbox,
    BFormCheckboxGroup,
    
    CompareChartStack,
    CompareChartStack2,
    CompareChartStackMerge,
    // CompareChartNet1,
    // CompareChartNet2,

    

  },
  props: {
    compareFirstClasses: {
      type: Array,
      default: () => [],
    },
    compareMiddleClass: {
      type: String,
      default: '',
    },
    compareDates: {
      type: Array,
      default: () => [],
    },
    compareBrand: {
      type: String,
      default: '',
    },
    compareShow1: {
      type: Boolean,
      default: false,
    },
    compareBrandList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      modalTitle: 'INSIGHT 경쟁분석',
      compareSelectedBrand1: null,
      compareSelectedBrand2: null,

      selectedDates1: [],
      selectedDates2: [],
      
      form1: {
        monthSelect: []
      },
      form2: {
        monthSelect: []
      },
      configs: {
        monthSelect: {
          mode: "range",
          altFormat: 'Y-m',
          plugins: [
            new monthSelectPlugin({
              shorthand: true,
              dateFormat: "Y-m",
            })
          ],
          locale: {
            rangeSeparator: ' ~ '
          },
          minDate:"2018-01-01",
          maxDate: moment().endOf('month').format('YYYY-MM-DD') // 이번 달 말일로 지정
        }
      },

      // 0번째 차트(원차트)
      compare01_total_search_freq: "",

      compare01_general_search_freq: "",
      compare01_general_search_rate: "",
      compare01_general_search_detail_1_nm: "",
      compare01_general_search_detail_1_freq: "",
      compare01_general_search_detail_1_rate: "",
      compare01_general_search_detail_2_nm: "",
      compare01_general_search_detail_2_freq: "",
      compare01_general_search_detail_2_rate: "",
      compare01_general_search_detail_3_nm: "",
      compare01_general_search_detail_3_freq: "",
      compare01_general_search_detail_3_rate: "",

      compare01_attribute_search_freq: "",
      compare01_attribute_search_rate: "",
      compare01_attribute_search_detail_1_nm: "",
      compare01_attribute_search_detail_1_freq: "",
      compare01_attribute_search_detail_1_rate: "",
      compare01_attribute_search_detail_2_nm: "",
      compare01_attribute_search_detail_2_freq: "",
      compare01_attribute_search_detail_2_rate: "",
      compare01_attribute_search_detail_3_nm: "",
      compare01_attribute_search_detail_3_freq: "",
      compare01_attribute_search_detail_3_rate: "",
      compare01_attribute_search_detail_4_nm: "",
      compare01_attribute_search_detail_4_freq: "",
      compare01_attribute_search_detail_4_rate: "",
      compare01_attribute_search_detail_5_nm: "",
      compare01_attribute_search_detail_5_freq: "",
      compare01_attribute_search_detail_5_rate: "",

      compare01_buy_manage_freq: "",
      compare01_buy_manage_rate: "",
      compare01_buy_manage_detail_1_nm: "",
      compare01_buy_manage_detail_1_freq: "",
      compare01_buy_manage_detail_1_rate: "",
      compare01_buy_manage_detail_2_nm: "",
      compare01_buy_manage_detail_2_freq: "",
      compare01_buy_manage_detail_2_rate: "",

      compareStackChartData0: [],
      compareStackChartCategory0: [],


      compare02_total_search_freq: "",

      compare02_general_search_freq: "",
      compare02_general_search_rate: "",
      compare02_general_search_detail_1_nm: "",
      compare02_general_search_detail_1_freq: "",
      compare02_general_search_detail_1_rate: "",
      compare02_general_search_detail_2_nm: "",
      compare02_general_search_detail_2_freq: "",
      compare02_general_search_detail_2_rate: "",
      compare02_general_search_detail_3_nm: "",
      compare02_general_search_detail_3_freq: "",
      compare02_general_search_detail_3_rate: "",

      compare02_attribute_search_freq: "",
      compare02_attribute_search_rate: "",
      compare02_attribute_search_detail_1_nm: "",
      compare02_attribute_search_detail_1_freq: "",
      compare02_attribute_search_detail_1_rate: "",
      compare02_attribute_search_detail_2_nm: "",
      compare02_attribute_search_detail_2_freq: "",
      compare02_attribute_search_detail_2_rate: "",
      compare02_attribute_search_detail_3_nm: "",
      compare02_attribute_search_detail_3_freq: "",
      compare02_attribute_search_detail_3_rate: "",
      compare02_attribute_search_detail_4_nm: "",
      compare02_attribute_search_detail_4_freq: "",
      compare02_attribute_search_detail_4_rate: "",
      compare02_attribute_search_detail_5_nm: "",
      compare02_attribute_search_detail_5_freq: "",
      compare02_attribute_search_detail_5_rate: "",

      compare02_buy_manage_freq: "",
      compare02_buy_manage_rate: "",
      compare02_buy_manage_detail_1_nm: "",
      compare02_buy_manage_detail_1_freq: "",
      compare02_buy_manage_detail_1_rate: "",
      compare02_buy_manage_detail_2_nm: "",
      compare02_buy_manage_detail_2_freq: "",
      compare02_buy_manage_detail_2_rate: "",

      compareStackChartData02: [],
      compareStackChartCategory02: [],


      // 첫번째 차트(투차트)
      compare1_total_search_freq: "",

      compare1_general_search_freq: "",
      compare1_general_search_rate: "",
      compare1_general_search_detail_1_nm: "",
      compare1_general_search_detail_1_freq: "",
      compare1_general_search_detail_1_rate: "",
      compare1_general_search_detail_2_nm: "",
      compare1_general_search_detail_2_freq: "",
      compare1_general_search_detail_2_rate: "",
      compare1_general_search_detail_3_nm: "",
      compare1_general_search_detail_3_freq: "",
      compare1_general_search_detail_3_rate: "",

      compare1_attribute_search_freq: "",
      compare1_attribute_search_rate: "",
      compare1_attribute_search_detail_1_nm: "",
      compare1_attribute_search_detail_1_freq: "",
      compare1_attribute_search_detail_1_rate: "",
      compare1_attribute_search_detail_2_nm: "",
      compare1_attribute_search_detail_2_freq: "",
      compare1_attribute_search_detail_2_rate: "",
      compare1_attribute_search_detail_3_nm: "",
      compare1_attribute_search_detail_3_freq: "",
      compare1_attribute_search_detail_3_rate: "",
      compare1_attribute_search_detail_4_nm: "",
      compare1_attribute_search_detail_4_freq: "",
      compare1_attribute_search_detail_4_rate: "",
      compare1_attribute_search_detail_5_nm: "",
      compare1_attribute_search_detail_5_freq: "",
      compare1_attribute_search_detail_5_rate: "",

      compare1_buy_manage_freq: "",
      compare1_buy_manage_rate: "",
      compare1_buy_manage_detail_1_nm: "",
      compare1_buy_manage_detail_1_freq: "",
      compare1_buy_manage_detail_1_rate: "",
      compare1_buy_manage_detail_2_nm: "",
      compare1_buy_manage_detail_2_freq: "",
      compare1_buy_manage_detail_2_rate: "",

      compareStackChartData1: [],
      compareStackChartCategory1: [],


      // 두번째 차트(투차트)
      compare2_total_search_freq: "",

      compare2_general_search_freq: "",
      compare2_general_search_rate: "",
      compare2_general_search_detail_1_nm: "",
      compare2_general_search_detail_1_freq: "",
      compare2_general_search_detail_1_rate: "",
      compare2_general_search_detail_2_nm: "",
      compare2_general_search_detail_2_freq: "",
      compare2_general_search_detail_2_rate: "",
      compare2_general_search_detail_3_nm: "",
      compare2_general_search_detail_3_freq: "",
      compare2_general_search_detail_3_rate: "",

      compare2_attribute_search_freq: "",
      compare2_attribute_search_rate: "",
      compare2_attribute_search_detail_1_nm: "",
      compare2_attribute_search_detail_1_freq: "",
      compare2_attribute_search_detail_1_rate: "",
      compare2_attribute_search_detail_2_nm: "",
      compare2_attribute_search_detail_2_freq: "",
      compare2_attribute_search_detail_2_rate: "",
      compare2_attribute_search_detail_3_nm: "",
      compare2_attribute_search_detail_3_freq: "",
      compare2_attribute_search_detail_3_rate: "",
      compare2_attribute_search_detail_4_nm: "",
      compare2_attribute_search_detail_4_freq: "",
      compare2_attribute_search_detail_4_rate: "",
      compare2_attribute_search_detail_5_nm: "",
      compare2_attribute_search_detail_5_freq: "",
      compare2_attribute_search_detail_5_rate: "",

      compare2_buy_manage_freq: "",
      compare2_buy_manage_rate: "",
      compare2_buy_manage_detail_1_nm: "",
      compare2_buy_manage_detail_1_freq: "",
      compare2_buy_manage_detail_1_rate: "",
      compare2_buy_manage_detail_2_nm: "",
      compare2_buy_manage_detail_2_freq: "",
      compare2_buy_manage_detail_2_rate: "",

      compareStackChartData2: [],
      compareStackChartCategory2: [],



      
    };
  },
  watch: {
    compareShow1(){
      console.log('-- watch compareShow1 --')      
      console.log(this.compareShow1)
      this.compareSelectedBrand1 = this.compareBrand

      this.form1.monthSelect = [moment(this.compareDates[0]).format("YYYY-MM"), moment(this.compareDates[1]).format("YYYY-MM")]
      this.form2.monthSelect = [moment(this.compareDates[0]).format("YYYY-MM"), moment(this.compareDates[1]).format("YYYY-MM")]

      // compareShow1 이 true 일 때 데이터 로드 해야함
      if(this.compareShow1){
        this.loadCompareDataBoth()
      }
    },
    compareSelectedBrand1(){
      if(document.getElementById('oneChartRow')){
        if(document.getElementById('oneChartRow').style.display == 'none'){
          this.loadCompareCDJTableLeft()
        }else{
          this.loadCompareCDJTableMerge()
        }
      }
    },
    compareSelectedBrand2(){
      if(document.getElementById('oneChartRow')){
        if(document.getElementById('oneChartRow').style.display == 'none'){
          this.loadCompareCDJTableRight()
        }else{
          this.loadCompareCDJTableMerge()
        }
      }
    },
  },
  methods: {
    datePickerOnOpen1(selectedDates1, dateStr, instance) {
      if (document.querySelector(".fp-max-duration-info") == null) {
        var divEl = document.createElement("div"); 
        divEl.setAttribute('class', 'fp-max-duration-info');   
        divEl.setAttribute('align', 'left');   
        divEl.setAttribute('style', 'margin: 2px 10px; font-family: NanumBarunGothic; font-size: 12px; font-weight: 600; color: #17a2b8;');   
        divEl.innerHTML = "&#9888; 분석기간은 최대 3년 입니다.";
        document.querySelector(".flatpickr-calendar").appendChild(divEl);
      }
    },

    datePickerOnChange1(selectedDates1, dateStr, instance) {
      instance.element.value = dateStr.replace('to', '~')

      var [st_dt, en_dt] = selectedDates1;
      
      if (en_dt == null) {
        var newMindate = moment(st_dt).add(-35, 'month')
        var newMaxdate = moment(st_dt).add( 35, 'month')

        if (newMindate.isBefore(this.configs.monthSelect.minDate)) 
          newMindate = moment(this.configs.monthSelect.minDate);

        if (newMaxdate.isAfter(this.configs.monthSelect.maxDate)) 
          newMaxdate = moment(this.configs.monthSelect.maxDate);

        instance.config.minDate = newMindate.toDate()
        instance.config.maxDate = newMaxdate.toDate()
      }
    },

    datepickerCloseHandler1(selectedDates1, dateStr, instance) {
      var [st_dt, en_dt] = selectedDates1;

      if (en_dt) {
        var diff_month = (en_dt.getYear() - st_dt.getYear()) * 12 + (en_dt.getMonth() - st_dt.getMonth() + 1);

        if (diff_month > 36) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "설정 가능한 최대 분석 기간은 3년(36개월)입니다." || "Unknown error",
              icon: "AlertCircleIcon",
              variant: "warning",
            },
          });

          var curr_dt = new Date()
          var avail_diff_month = (curr_dt.getYear() - st_dt.getYear()) * 12 + (curr_dt.getMonth() - st_dt.getMonth());

          if (avail_diff_month > 35)
            avail_diff_month = 35
          
          en_dt = moment(st_dt).add(avail_diff_month, 'month').toDate()

          this.form1.monthSelect = [st_dt, en_dt]
        }
        else
          this.form1.monthSelect = selectedDates1;

        var st_dt_str = moment(st_dt).format("YYYY-MM")
        var en_dt_str = moment(en_dt).format("YYYY-MM")

        if(this.selectedDates1[0] != st_dt_str || this.selectedDates1[1] != en_dt_str){
          this.selectedDates1 = []
          this.selectedDates1.push(st_dt_str)
          this.selectedDates1.push(en_dt_str)
          this.preAnalysisPeriod = [st_dt_str, en_dt_str]
          this.comAnalysisPeriod = [st_dt_str, en_dt_str]
          this.purAnalysisPeriod = [st_dt_str, en_dt_str]

          this.curMonthIdx = moment(en_dt_str).diff(moment(st_dt_str), 'month');
          this.curYearIdx = moment(en_dt_str.substr(0,4)).diff(moment(st_dt_str.substr(0,4)), 'years');   

          this.$store.dispatch('callPeriodSt', { st_dt: st_dt })
          this.$store.dispatch('callPeriodEn', { en_dt: en_dt })          
        }      
      }
      else
        instance.setDate([this.form1.monthSelect[0], this.form1.monthSelect[1]], true)

      this.loadCompareCDJTableLeft()
    },

    datePickerOnOpen2(selectedDates2, dateStr, instance) {
      if (document.querySelector(".fp-max-duration-info") == null) {
        var divEl = document.createElement("div"); 
        divEl.setAttribute('class', 'fp-max-duration-info');   
        divEl.setAttribute('align', 'left');   
        divEl.setAttribute('style', 'margin: 2px 10px; font-family: NanumBarunGothic; font-size: 12px; font-weight: 600; color: #17a2b8;');   
        divEl.innerHTML = "&#9888; 분석기간은 최대 3년 입니다.";
        document.querySelector(".flatpickr-calendar").appendChild(divEl);
      }
    },

    datePickerOnChange2(selectedDates2, dateStr, instance) {
      instance.element.value = dateStr.replace('to', '~')

      var [st_dt, en_dt] = selectedDates2;
      
      if (en_dt == null) {
        var newMindate = moment(st_dt).add(-35, 'month')
        var newMaxdate = moment(st_dt).add( 35, 'month')

        if (newMindate.isBefore(this.configs.monthSelect.minDate)) 
          newMindate = moment(this.configs.monthSelect.minDate);

        if (newMaxdate.isAfter(this.configs.monthSelect.maxDate)) 
          newMaxdate = moment(this.configs.monthSelect.maxDate);

        instance.config.minDate = newMindate.toDate()
        instance.config.maxDate = newMaxdate.toDate()
      }
    },

    datepickerCloseHandler2(selectedDates2, dateStr, instance) {
      var [st_dt, en_dt] = selectedDates2;

      if (en_dt) {
        var diff_month = (en_dt.getYear() - st_dt.getYear()) * 12 + (en_dt.getMonth() - st_dt.getMonth() + 1);

        if (diff_month > 36) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "설정 가능한 최대 분석 기간은 3년(36개월)입니다." || "Unknown error",
              icon: "AlertCircleIcon",
              variant: "warning",
            },
          });

          var curr_dt = new Date()
          var avail_diff_month = (curr_dt.getYear() - st_dt.getYear()) * 12 + (curr_dt.getMonth() - st_dt.getMonth());

          if (avail_diff_month > 35)
            avail_diff_month = 35
          
          en_dt = moment(st_dt).add(avail_diff_month, 'month').toDate()

          this.form2.monthSelect = [st_dt, en_dt]
        }
        else
          this.form2.monthSelect = selectedDates2;

        var st_dt_str = moment(st_dt).format("YYYY-MM")
        var en_dt_str = moment(en_dt).format("YYYY-MM")

        if(this.selectedDates2[0] != st_dt_str || this.selectedDates2[1] != en_dt_str){
          this.selectedDates2 = []
          this.selectedDates2.push(st_dt_str)
          this.selectedDates2.push(en_dt_str)
          this.preAnalysisPeriod = [st_dt_str, en_dt_str]
          this.comAnalysisPeriod = [st_dt_str, en_dt_str]
          this.purAnalysisPeriod = [st_dt_str, en_dt_str]

          this.curMonthIdx = moment(en_dt_str).diff(moment(st_dt_str), 'month');
          this.curYearIdx = moment(en_dt_str.substr(0,4)).diff(moment(st_dt_str.substr(0,4)), 'years');   

          this.$store.dispatch('callPeriodSt', { st_dt: st_dt })
          this.$store.dispatch('callPeriodEn', { en_dt: en_dt })          
        }      
      }
      else
        instance.setDate([this.form2.monthSelect[0], this.form2.monthSelect[1]], true)

      this.loadCompareCDJTableRight()
    },

    resetModal(){
      console.log('-- resetModal --')
      // 부모가 compareShow1을 false로 바꿔야함
      this.$parent.changeCompareShow1()
      this.compareSelectedBrand2 = '';
    },

    swapChart(){
      console.log('-- swapChart --')
      console.log(document.getElementById('twoChartRow'))
      console.log(document.getElementById('twoChartRow').style.display)
      console.log(document.getElementById('oneChartRow'))
      console.log(document.getElementById('oneChartRow').style.display)
      
      if(document.getElementById('oneChartRow').style.display == 'none'){
        document.getElementById('twoChartRow').style.display = 'none'
        document.getElementById('oneChartRow').style.display = 'block'

        this.loadCompareCDJTableMerge()


      }else{
        document.getElementById('oneChartRow').style.display = 'none'
        document.getElementById('twoChartRow').style.display = 'flex'

        this.loadCompareDataBoth()

      }

    },

    async loadCompareDataBoth(){
      console.log('-- loadCompareDataBoth --')
      this.loadCompareCDJTableLeft()
      this.loadCompareCDJTableRight()
    },

    async loadCompareCDJTableMerge(){
      console.log('-- loadCompareCDJTableMerge --')
      var startDate = moment(this.compareDates[0]).format("YYYY-MM")
      var endDate = moment(this.compareDates[1]).add(1, 'month').format("YYYY-MM")
      var firstClassList = []
      for(const item of this.compareFirstClasses)
        firstClassList.push(item)
      var sel_Middle = this.compareMiddleClass != null ? this.compareMiddleClass : null; 
      if (sel_Middle == '중분류 없음')
        sel_Middle = '기타'

      // stackChart 초기화
      this.compareStackChartData0 = []
      this.compareStackChartCategory0 = []
      if(document.getElementById('compareLoadingStack0')){
        document.getElementById('compareLoadingStack0').style.visibility = "visible";
      }
      if(document.getElementById('compareStackChart0')){
        document.getElementById('compareStackChart0').style.visibility = "hidden";
      }

      // 첫번째 브랜드 값 가져오기
      var brandList = []
      if(this.compareSelectedBrand1 != '' && this.compareSelectedBrand1 != null )
        brandList.push(this.compareSelectedBrand1)


      const response = await CisInsightService.getInsightDataCDJTable({
        startDate : startDate,
        endDate : endDate,
        ctgSq : this.$store.getters.getSelectedCategory,
        brandList : brandList,
        firstClassList : firstClassList,
        selMiddle: sel_Middle
      }, source);

      if (response && response.status === 200) {
        console.log('-- CDJ 테이블 data --')
        console.log(response)

        this.compare01_total_search_freq = Math.round((response.data.data[0].freq + response.data.data[1].freq + response.data.data[2].freq + response.data.data[3].freq + response.data.data[4].freq + response.data.data[5].freq + response.data.data[6].freq + response.data.data[7].freq + response.data.data[8].freq + response.data.data[9].freq)*100)/100
        this.compare01_general_search_freq = Math.round((response.data.data[0].freq + response.data.data[1].freq + response.data.data[2].freq)*100)/100
        this.compare01_general_search_rate = Math.round((response.data.data[0].rate + response.data.data[1].rate + response.data.data[2].rate))
        this.compare01_general_search_rate = this.compare1_general_search_rate + "%"
        this.compare01_attribute_search_freq = Math.round((response.data.data[3].freq + response.data.data[4].freq + response.data.data[5].freq + response.data.data[6].freq + response.data.data[7].freq)*100)/100
        this.compare01_attribute_search_rate = Math.round((response.data.data[3].rate + response.data.data[4].rate + response.data.data[5].rate + response.data.data[6].rate + response.data.data[7].rate))
        this.compare01_attribute_search_rate = this.compare1_attribute_search_rate + "%"
        this.compare01_buy_manage_freq = Math.round((response.data.data[8].freq + response.data.data[9].freq)*100)/100
        this.compare01_buy_manage_rate = Math.round((response.data.data[8].rate + response.data.data[9].rate))
        this.compare01_buy_manage_rate = this.compare1_buy_manage_rate + "%"

        this.compare01_general_search_detail_1_nm = response.data.data[0].cdjDetails
        this.compare01_general_search_detail_1_freq = response.data.data[0].freq
        this.compare01_general_search_detail_1_rate = response.data.data[0].rate
        this.compare01_general_search_detail_1_rate = this.compare01_general_search_detail_1_rate +"%"
        this.compare01_general_search_detail_2_nm = response.data.data[1].cdjDetails
        this.compare01_general_search_detail_2_freq = response.data.data[1].freq
        this.compare01_general_search_detail_2_rate = response.data.data[1].rate
        this.compare01_general_search_detail_2_rate = this.compare01_general_search_detail_2_rate + "%"
        this.compare01_general_search_detail_3_nm = response.data.data[2].cdjDetails
        this.compare01_general_search_detail_3_freq = response.data.data[2].freq
        this.compare01_general_search_detail_3_rate = response.data.data[2].rate
        this.compare01_general_search_detail_3_rate = this.compare01_general_search_detail_3_rate + "%"

        this.compare01_attribute_search_detail_1_nm = response.data.data[3].cdjDetails
        this.compare01_attribute_search_detail_1_freq = response.data.data[3].freq
        this.compare01_attribute_search_detail_1_rate = response.data.data[3].rate
        this.compare01_attribute_search_detail_1_rate = this.compare01_attribute_search_detail_1_rate + "%"
        this.compare01_attribute_search_detail_2_nm = response.data.data[4].cdjDetails
        this.compare01_attribute_search_detail_2_freq = response.data.data[4].freq
        this.compare01_attribute_search_detail_2_rate = response.data.data[4].rate
        this.compare01_attribute_search_detail_2_rate = this.compare01_attribute_search_detail_2_rate + "%"
        this.compare01_attribute_search_detail_3_nm = response.data.data[5].cdjDetails
        this.compare01_attribute_search_detail_3_freq = response.data.data[5].freq
        this.compare01_attribute_search_detail_3_rate = response.data.data[5].rate
        this.compare01_attribute_search_detail_3_rate = this.compare01_attribute_search_detail_3_rate +"%"
        this.compare01_attribute_search_detail_4_nm = response.data.data[6].cdjDetails
        this.compare01_attribute_search_detail_4_freq = response.data.data[6].freq
        this.compare01_attribute_search_detail_4_rate = response.data.data[6].rate
        this.compare01_attribute_search_detail_4_rate = this.compare01_attribute_search_detail_4_rate +"%"
        this.compare01_attribute_search_detail_5_nm = response.data.data[7].cdjDetails
        this.compare01_attribute_search_detail_5_freq = response.data.data[7].freq
        this.compare01_attribute_search_detail_5_rate = response.data.data[7].rate
        this.compare01_attribute_search_detail_5_rate = this.compare01_attribute_search_detail_5_rate +"%"

        this.compare01_buy_manage_detail_1_nm = response.data.data[8].cdjDetails
        this.compare01_buy_manage_detail_1_freq = response.data.data[8].freq
        this.compare01_buy_manage_detail_1_rate = response.data.data[8].rate
        this.compare01_buy_manage_detail_1_rate = this.compare01_buy_manage_detail_1_rate +"%"
        this.compare01_buy_manage_detail_2_nm = response.data.data[9].cdjDetails
        this.compare01_buy_manage_detail_2_freq = response.data.data[9].freq
        this.compare01_buy_manage_detail_2_rate = response.data.data[9].rate
        this.compare01_buy_manage_detail_2_rate = this.compare01_buy_manage_detail_2_rate + "%"
      }


      // 두번째 브랜드 값 가져오기
      var brandList = []
      if(this.compareSelectedBrand2 != '' && this.compareSelectedBrand2 != null )
        brandList.push(this.compareSelectedBrand2)


      const response2 = await CisInsightService.getInsightDataCDJTable2({
        startDate : startDate,
        endDate : endDate,
        ctgSq : this.$store.getters.getSelectedCategory,
        brandList : brandList,
        firstClassList : firstClassList,
        selMiddle: sel_Middle,
        general1: this.compare01_general_search_detail_1_nm,
        general2: this.compare01_general_search_detail_2_nm,
        general3: this.compare01_general_search_detail_3_nm,
        attribute1: this.compare01_attribute_search_detail_1_nm,
        attribute2: this.compare01_attribute_search_detail_2_nm,
        attribute3: this.compare01_attribute_search_detail_3_nm,
        attribute4: this.compare01_attribute_search_detail_4_nm,
        attribute5: [this.compare01_attribute_search_detail_1_nm, this.compare01_attribute_search_detail_2_nm, this.compare01_attribute_search_detail_3_nm, this.compare01_attribute_search_detail_4_nm], 
        buy1: this.compare01_buy_manage_detail_1_nm,
        buy2: this.compare01_buy_manage_detail_2_nm
      }, source);

      if (response2 && response2.status === 200) {
        console.log('-- CDJ 테이블 data2 --')
        console.log(response2)

        this.compare02_total_search_freq = Math.round((response2.data.data[0].freq + response2.data.data[1].freq + response2.data.data[2].freq + response2.data.data[3].freq + response2.data.data[4].freq + response2.data.data[5].freq + response2.data.data[6].freq + response2.data.data[7].freq + response2.data.data[8].freq + response2.data.data[9].freq)*100)/100
        this.compare02_general_search_freq = Math.round((response2.data.data[0].freq + response2.data.data[1].freq + response2.data.data[2].freq)*100)/100
        this.compare02_general_search_rate = Math.round((response2.data.data[0].rate + response2.data.data[1].rate + response2.data.data[2].rate))
        this.compare02_general_search_rate = this.compare2_general_search_rate + "%"
        this.compare02_attribute_search_freq = Math.round((response2.data.data[3].freq + response2.data.data[4].freq + response2.data.data[5].freq + response2.data.data[6].freq + response2.data.data[7].freq)*100)/100
        this.compare02_attribute_search_rate = Math.round((response2.data.data[3].rate + response2.data.data[4].rate + response2.data.data[5].rate + response2.data.data[6].rate + response2.data.data[7].rate))
        this.compare02_attribute_search_rate = this.compare2_attribute_search_rate + "%"
        this.compare02_buy_manage_freq = Math.round((response2.data.data[8].freq + response2.data.data[9].freq)*100)/100
        this.compare02_buy_manage_rate = Math.round((response2.data.data[8].rate + response2.data.data[9].rate))
        this.compare02_buy_manage_rate = this.compare2_buy_manage_rate + "%"

        this.compare02_general_search_detail_1_nm = response2.data.data[0].cdjDetails
        this.compare02_general_search_detail_1_freq = response2.data.data[0].freq
        this.compare02_general_search_detail_1_rate = response2.data.data[0].rate
        this.compare02_general_search_detail_1_rate = this.compare02_general_search_detail_1_rate +"%"
        this.compare02_general_search_detail_2_nm = response2.data.data[1].cdjDetails
        this.compare02_general_search_detail_2_freq = response2.data.data[1].freq
        this.compare02_general_search_detail_2_rate = response2.data.data[1].rate
        this.compare02_general_search_detail_2_rate = this.compare02_general_search_detail_2_rate + "%"
        this.compare02_general_search_detail_3_nm = response2.data.data[2].cdjDetails
        this.compare02_general_search_detail_3_freq = response2.data.data[2].freq
        this.compare02_general_search_detail_3_rate = response2.data.data[2].rate
        this.compare02_general_search_detail_3_rate = this.compare02_general_search_detail_3_rate + "%"

        this.compare02_attribute_search_detail_1_nm = response2.data.data[3].cdjDetails
        this.compare02_attribute_search_detail_1_freq = response2.data.data[3].freq
        this.compare02_attribute_search_detail_1_rate = response2.data.data[3].rate
        this.compare02_attribute_search_detail_1_rate = this.compare02_attribute_search_detail_1_rate + "%"
        this.compare02_attribute_search_detail_2_nm = response2.data.data[4].cdjDetails
        this.compare02_attribute_search_detail_2_freq = response2.data.data[4].freq
        this.compare02_attribute_search_detail_2_rate = response2.data.data[4].rate
        this.compare02_attribute_search_detail_2_rate = this.compare02_attribute_search_detail_2_rate + "%"
        this.compare02_attribute_search_detail_3_nm = response2.data.data[5].cdjDetails
        this.compare02_attribute_search_detail_3_freq = response2.data.data[5].freq
        this.compare02_attribute_search_detail_3_rate = response2.data.data[5].rate
        this.compare02_attribute_search_detail_3_rate = this.compare02_attribute_search_detail_3_rate +"%"
        this.compare02_attribute_search_detail_4_nm = response2.data.data[6].cdjDetails
        this.compare02_attribute_search_detail_4_freq = response2.data.data[6].freq
        this.compare02_attribute_search_detail_4_rate = response2.data.data[6].rate
        this.compare02_attribute_search_detail_4_rate = this.compare02_attribute_search_detail_4_rate +"%"
        this.compare02_attribute_search_detail_5_nm = response2.data.data[7].cdjDetails
        this.compare02_attribute_search_detail_5_freq = response2.data.data[7].freq
        this.compare02_attribute_search_detail_5_rate = response2.data.data[7].rate
        this.compare02_attribute_search_detail_5_rate = this.compare02_attribute_search_detail_5_rate +"%"

        this.compare02_buy_manage_detail_1_nm = response2.data.data[8].cdjDetails
        this.compare02_buy_manage_detail_1_freq = response2.data.data[8].freq
        this.compare02_buy_manage_detail_1_rate = response2.data.data[8].rate
        this.compare02_buy_manage_detail_1_rate = this.compare02_buy_manage_detail_1_rate +"%"
        this.compare02_buy_manage_detail_2_nm = response2.data.data[9].cdjDetails
        this.compare02_buy_manage_detail_2_freq = response2.data.data[9].freq
        this.compare02_buy_manage_detail_2_rate = response2.data.data[9].rate
        this.compare02_buy_manage_detail_2_rate = this.compare02_buy_manage_detail_2_rate + "%"

        // stackedChart
        this.loadCompareStackedMerge(response.data.data);
      }
    },

    async loadCompareStackedMerge(cdjTableData){
      console.log('-- loadCompareStackedMerge --')

      this.compareStackChartData0 = []
      this.compareStackChartCategory0 = []
      for(const item of cdjTableData)
        this.compareStackChartCategory0.push(item.cdjDetails)

      var startDate = moment(this.compareDates[0]).format("YYYY-MM")
      var endDate = moment(this.compareDates[1]).add(1, 'month').format("YYYY-MM")

      var firstClassList = []
      for(const item of this.compareFirstClasses)
        firstClassList.push(item)

      var sel_Middle = this.compareMiddleClass != null ? this.compareMiddleClass : null; 
      if (sel_Middle == '중분류 없음')
        sel_Middle = '기타'

      var brandList1 = []
      if(this.compareSelectedBrand1 != '' && this.compareSelectedBrand1 != null )      
        brandList1.push(this.compareSelectedBrand1)

      var brandList2 = []
      if(this.compareSelectedBrand2 != '' && this.compareSelectedBrand2 != null )      
        brandList2.push(this.compareSelectedBrand2)


      const response = await CisInsightService.getInsightDataStackedMerge({
        startDate : startDate,
        endDate : endDate,
        ctgSq : this.$store.getters.getSelectedCategory,
        brandList1 : brandList1,
        brandList2 : brandList2,
        firstClassList : firstClassList,
        selMiddle: sel_Middle, 
        cdjDetail1 : this.compare01_general_search_detail_1_nm,
        cdjDetail2 : this.compare01_general_search_detail_2_nm,
        cdjDetail3 : this.compare01_general_search_detail_3_nm,
        cdjDetail4 : this.compare01_attribute_search_detail_1_nm,
        cdjDetail5 : this.compare01_attribute_search_detail_2_nm,
        cdjDetail6 : this.compare01_attribute_search_detail_3_nm,
        cdjDetail7 : this.compare01_attribute_search_detail_4_nm,
        cdjDetail8 : this.compare01_attribute_search_detail_5_nm,
        cdjDetail9 : this.compare01_buy_manage_detail_1_nm,
        cdjDetail10 : this.compare01_buy_manage_detail_2_nm
      }, source);

      if (response && response.status === 200) {
        console.log('-- 중단 Merge Stacked data --')
        console.log(response)

        // min height 설정
        var minHeight = Math.round((100/9)*100)/100

        // stacked chart update
        this.compareStackChartData0 = []
        var stackDatas = []

        for(const item of response.data.data) {
          var heights_pre = item.rate.split(',')
          var heights = []

          for (const height of heights_pre){
            if (height == 0)
              heights.push(0)
            else if (height > minHeight)
              heights.push(minHeight)
            else
              heights.push(minHeight)            
          }

          var keywords = item.keyword.split(',')
          var freqs = item.freq.split(',')
          var rates = item.rate.split(',')

          stackDatas = []
          stackDatas.push(keywords)
          stackDatas.push(freqs)
          stackDatas.push(rates)
          stackDatas.push(heights)
          this.compareStackChartData0.push(stackDatas)
        }
        
        if(document.getElementById('compareLoadingStack0')){
          document.getElementById('compareLoadingStack0').style.visibility = "hidden";
        }
        if(document.getElementById('compareStackChart0')){
          document.getElementById('compareStackChart0').style.visibility = "visible";
        }
      }




    },




    async loadCompareCDJTableLeft(){
      console.log('-- loadCompareCDJTableLeft --')

      // right확인
      // console.log('-- right 확인 ')
      // console.log(this.compareSelectedBrand2)
      // console.log(this.compare2_total_search_freq)
      // if((this.compareSelectedBrand2 == null) && (this.compare2_total_search_freq == '')){
      //   this.loadCompareCDJTableRight()
      // }

      var startDate = moment(this.form1.monthSelect[0]).format("YYYY-MM")
      var endDate = moment(this.form1.monthSelect[1]).add(1, 'month').format("YYYY-MM")


      var firstClassList = []
      for(const item of this.compareFirstClasses)
        firstClassList.push(item)

      var sel_Middle = this.compareMiddleClass != null ? this.compareMiddleClass : null; 

      if (sel_Middle == '중분류 없음')
        sel_Middle = '기타'

      var brandList = []
      if(this.compareSelectedBrand1 != '' && this.compareSelectedBrand1 != null )
        brandList.push(this.compareSelectedBrand1)

      // stackChart 초기화
      this.compareStackChartData1 = []
      this.compareStackChartCategory1 = []
      if(document.getElementById('compareLoadingStack1')){
        document.getElementById('compareLoadingStack1').style.visibility = "visible";
      }
      if(document.getElementById('compareStackChart1')){
        document.getElementById('compareStackChart1').style.visibility = "hidden";
      }
      
      

      const response = await CisInsightService.getInsightDataCDJTable({
        startDate : startDate,
        endDate : endDate,
        ctgSq : this.$store.getters.getSelectedCategory,
        brandList : brandList,
        firstClassList : firstClassList,
        selMiddle: sel_Middle
      }, source);

      if (response && response.status === 200) {
        console.log('-- CDJ 테이블 data --')
        console.log(response)

        this.compare1_total_search_freq = Math.round((response.data.data[0].freq + response.data.data[1].freq + response.data.data[2].freq + response.data.data[3].freq + response.data.data[4].freq + response.data.data[5].freq + response.data.data[6].freq + response.data.data[7].freq + response.data.data[8].freq + response.data.data[9].freq)*100)/100
        this.compare1_general_search_freq = Math.round((response.data.data[0].freq + response.data.data[1].freq + response.data.data[2].freq)*100)/100
        this.compare1_general_search_rate = Math.round((response.data.data[0].rate + response.data.data[1].rate + response.data.data[2].rate))
        this.compare1_general_search_rate = this.compare1_general_search_rate + "%"
        this.compare1_attribute_search_freq = Math.round((response.data.data[3].freq + response.data.data[4].freq + response.data.data[5].freq + response.data.data[6].freq + response.data.data[7].freq)*100)/100
        this.compare1_attribute_search_rate = Math.round((response.data.data[3].rate + response.data.data[4].rate + response.data.data[5].rate + response.data.data[6].rate + response.data.data[7].rate))
        this.compare1_attribute_search_rate = this.compare1_attribute_search_rate + "%"
        this.compare1_buy_manage_freq = Math.round((response.data.data[8].freq + response.data.data[9].freq)*100)/100
        this.compare1_buy_manage_rate = Math.round((response.data.data[8].rate + response.data.data[9].rate))
        this.compare1_buy_manage_rate = this.compare1_buy_manage_rate + "%"

        this.compare1_general_search_detail_1_nm = response.data.data[0].cdjDetails
        this.compare1_general_search_detail_1_freq = response.data.data[0].freq
        this.compare1_general_search_detail_1_rate = response.data.data[0].rate
        this.compare1_general_search_detail_1_rate = this.compare1_general_search_detail_1_rate +"%"
        this.compare1_general_search_detail_2_nm = response.data.data[1].cdjDetails
        this.compare1_general_search_detail_2_freq = response.data.data[1].freq
        this.compare1_general_search_detail_2_rate = response.data.data[1].rate
        this.compare1_general_search_detail_2_rate = this.compare1_general_search_detail_2_rate + "%"
        this.compare1_general_search_detail_3_nm = response.data.data[2].cdjDetails
        this.compare1_general_search_detail_3_freq = response.data.data[2].freq
        this.compare1_general_search_detail_3_rate = response.data.data[2].rate
        this.compare1_general_search_detail_3_rate = this.compare1_general_search_detail_3_rate + "%"

        this.compare1_attribute_search_detail_1_nm = response.data.data[3].cdjDetails
        this.compare1_attribute_search_detail_1_freq = response.data.data[3].freq
        this.compare1_attribute_search_detail_1_rate = response.data.data[3].rate
        this.compare1_attribute_search_detail_1_rate = this.compare1_attribute_search_detail_1_rate + "%"
        this.compare1_attribute_search_detail_2_nm = response.data.data[4].cdjDetails
        this.compare1_attribute_search_detail_2_freq = response.data.data[4].freq
        this.compare1_attribute_search_detail_2_rate = response.data.data[4].rate
        this.compare1_attribute_search_detail_2_rate = this.compare1_attribute_search_detail_2_rate + "%"
        this.compare1_attribute_search_detail_3_nm = response.data.data[5].cdjDetails
        this.compare1_attribute_search_detail_3_freq = response.data.data[5].freq
        this.compare1_attribute_search_detail_3_rate = response.data.data[5].rate
        this.compare1_attribute_search_detail_3_rate = this.compare1_attribute_search_detail_3_rate +"%"
        this.compare1_attribute_search_detail_4_nm = response.data.data[6].cdjDetails
        this.compare1_attribute_search_detail_4_freq = response.data.data[6].freq
        this.compare1_attribute_search_detail_4_rate = response.data.data[6].rate
        this.compare1_attribute_search_detail_4_rate = this.compare1_attribute_search_detail_4_rate +"%"
        this.compare1_attribute_search_detail_5_nm = response.data.data[7].cdjDetails
        this.compare1_attribute_search_detail_5_freq = response.data.data[7].freq
        this.compare1_attribute_search_detail_5_rate = response.data.data[7].rate
        this.compare1_attribute_search_detail_5_rate = this.compare1_attribute_search_detail_5_rate +"%"

        this.compare1_buy_manage_detail_1_nm = response.data.data[8].cdjDetails
        this.compare1_buy_manage_detail_1_freq = response.data.data[8].freq
        this.compare1_buy_manage_detail_1_rate = response.data.data[8].rate
        this.compare1_buy_manage_detail_1_rate = this.compare1_buy_manage_detail_1_rate +"%"
        this.compare1_buy_manage_detail_2_nm = response.data.data[9].cdjDetails
        this.compare1_buy_manage_detail_2_freq = response.data.data[9].freq
        this.compare1_buy_manage_detail_2_rate = response.data.data[9].rate
        this.compare1_buy_manage_detail_2_rate = this.compare1_buy_manage_detail_2_rate + "%"

        var max_rate = 0

        for(const item of response.data.data){
          if(item.rate > max_rate)
            max_rate = item.rate
        }

        // stackedChart
        this.loadCompareStackedLeft(response.data.data, max_rate);
      }
    },


    async loadCompareStackedLeft(cdjTableData, maxRate){
      console.log('-- loadCompareStackedLeft --')

      this.compareStackChartData1 = []

      // stacked chart category setting
      this.compareStackChartCategory1 = []

      for(const item of cdjTableData)
        this.compareStackChartCategory1.push(item.cdjDetails)

      var startDate = moment(this.form1.monthSelect[0]).format("YYYY-MM")
      var endDate = moment(this.form1.monthSelect[1]).add(1, 'month').format("YYYY-MM")

      var firstClassList = []

      for(const item of this.compareFirstClasses)
        firstClassList.push(item)

      var sel_Middle = this.compareMiddleClass != null ? this.compareMiddleClass : null; 

      if (sel_Middle == '중분류 없음')
        sel_Middle = '기타'

      var brandList = []

      if(this.compareSelectedBrand1 != '' && this.compareSelectedBrand1 != null )      
        brandList.push(this.compareSelectedBrand1)

      const response = await CisInsightService.getInsightDataStacked({
        startDate : startDate,
        endDate : endDate,
        ctgSq : this.$store.getters.getSelectedCategory,
        brandList : brandList,
        firstClassList : firstClassList,
        selMiddle: sel_Middle, 
        cdjDetail1 : this.compareStackChartCategory1[0],
        cdjDetail2 : this.compareStackChartCategory1[1],
        cdjDetail3 : this.compareStackChartCategory1[2],
        cdjDetail4 : this.compareStackChartCategory1[3],
        cdjDetail5 : this.compareStackChartCategory1[4],
        cdjDetail6 : this.compareStackChartCategory1[5],
        cdjDetail7 : this.compareStackChartCategory1[6],
        cdjDetail8 : this.compareStackChartCategory1[7],
        cdjDetail9 : this.compareStackChartCategory1[8],
        cdjDetail10 : this.compareStackChartCategory1[9]
      }, source);

      if (response && response.status === 200) {
        console.log('-- 중단 Stacked data --')
        console.log(response)

        // min height 설정
        var minHeight = Math.round((100/9)*100)/100

        // stacked chart update
        this.compareStackChartData1 = []
        var stackDatas = []

        for(const item of response.data.data) {
          var heights_pre = item.rate.split(',')
          var heights = []

          for (const height of heights_pre){
            if (height == 0)
              heights.push(0)
            else if (height > minHeight)
              heights.push(minHeight)
            else
              heights.push(minHeight)            
          }

          var keywords = item.keyword.split(',')
          var freqs = item.freq.split(',')
          var rates = item.rate.split(',')

          stackDatas = []
          stackDatas.push(keywords)
          stackDatas.push(freqs)
          stackDatas.push(rates)
          stackDatas.push(heights)
          this.compareStackChartData1.push(stackDatas)
        }
        
        if(document.getElementById('compareLoadingStack1')){
          document.getElementById('compareLoadingStack1').style.visibility = "hidden";
        }
        if(document.getElementById('compareStackChart1')){
          document.getElementById('compareStackChart1').style.visibility = "visible";
        }
      }
    },

    async loadCompareCDJTableRight(){
      console.log('-- loadCompareCDJTableRight --')

      var startDate = moment(this.form2.monthSelect[0]).format("YYYY-MM")
      var endDate = moment(this.form2.monthSelect[1]).add(1, 'month').format("YYYY-MM")

      var firstClassList = []
      for(const item of this.compareFirstClasses)
        firstClassList.push(item)

      var sel_Middle = this.compareMiddleClass != null ? this.compareMiddleClass : null; 

      if (sel_Middle == '중분류 없음')
        sel_Middle = '기타'

      var brandList = []
      if(this.compareSelectedBrand2 != '' && this.compareSelectedBrand2 != null )
        brandList.push(this.compareSelectedBrand2)

      // stackChart 초기화
      this.compareStackChartData2 = []
      this.compareStackChartCategory2 = []
      if(document.getElementById('compareLoadingStack2')){
        document.getElementById('compareLoadingStack2').style.visibility = "visible";
      }
      if(document.getElementById('compareStackChart2')){
        document.getElementById('compareStackChart2').style.visibility = "hidden";
      }
      
      

      const response = await CisInsightService.getInsightDataCDJTable({
        startDate : startDate,
        endDate : endDate,
        ctgSq : this.$store.getters.getSelectedCategory,
        brandList : brandList,
        firstClassList : firstClassList,
        selMiddle: sel_Middle
      }, source);

      if (response && response.status === 200) {
        console.log('-- CDJ 테이블 data --')
        console.log(response)

        this.compare2_total_search_freq = Math.round((response.data.data[0].freq + response.data.data[1].freq + response.data.data[2].freq + response.data.data[3].freq + response.data.data[4].freq + response.data.data[5].freq + response.data.data[6].freq + response.data.data[7].freq + response.data.data[8].freq + response.data.data[9].freq)*100)/100
        this.compare2_general_search_freq = Math.round((response.data.data[0].freq + response.data.data[1].freq + response.data.data[2].freq)*100)/100
        this.compare2_general_search_rate = Math.round((response.data.data[0].rate + response.data.data[1].rate + response.data.data[2].rate))
        this.compare2_general_search_rate = this.compare2_general_search_rate + "%"
        this.compare2_attribute_search_freq = Math.round((response.data.data[3].freq + response.data.data[4].freq + response.data.data[5].freq + response.data.data[6].freq + response.data.data[7].freq)*100)/100
        this.compare2_attribute_search_rate = Math.round((response.data.data[3].rate + response.data.data[4].rate + response.data.data[5].rate + response.data.data[6].rate + response.data.data[7].rate))
        this.compare2_attribute_search_rate = this.compare2_attribute_search_rate + "%"
        this.compare2_buy_manage_freq = Math.round((response.data.data[8].freq + response.data.data[9].freq)*100)/100
        this.compare2_buy_manage_rate = Math.round((response.data.data[8].rate + response.data.data[9].rate))
        this.compare2_buy_manage_rate = this.compare2_buy_manage_rate + "%"

        this.compare2_general_search_detail_1_nm = response.data.data[0].cdjDetails
        this.compare2_general_search_detail_1_freq = response.data.data[0].freq
        this.compare2_general_search_detail_1_rate = response.data.data[0].rate
        this.compare2_general_search_detail_1_rate = this.compare2_general_search_detail_1_rate +"%"
        this.compare2_general_search_detail_2_nm = response.data.data[1].cdjDetails
        this.compare2_general_search_detail_2_freq = response.data.data[1].freq
        this.compare2_general_search_detail_2_rate = response.data.data[1].rate
        this.compare2_general_search_detail_2_rate = this.compare2_general_search_detail_2_rate + "%"
        this.compare2_general_search_detail_3_nm = response.data.data[2].cdjDetails
        this.compare2_general_search_detail_3_freq = response.data.data[2].freq
        this.compare2_general_search_detail_3_rate = response.data.data[2].rate
        this.compare2_general_search_detail_3_rate = this.compare2_general_search_detail_3_rate + "%"

        this.compare2_attribute_search_detail_1_nm = response.data.data[3].cdjDetails
        this.compare2_attribute_search_detail_1_freq = response.data.data[3].freq
        this.compare2_attribute_search_detail_1_rate = response.data.data[3].rate
        this.compare2_attribute_search_detail_1_rate = this.compare2_attribute_search_detail_1_rate + "%"
        this.compare2_attribute_search_detail_2_nm = response.data.data[4].cdjDetails
        this.compare2_attribute_search_detail_2_freq = response.data.data[4].freq
        this.compare2_attribute_search_detail_2_rate = response.data.data[4].rate
        this.compare2_attribute_search_detail_2_rate = this.compare2_attribute_search_detail_2_rate + "%"
        this.compare2_attribute_search_detail_3_nm = response.data.data[5].cdjDetails
        this.compare2_attribute_search_detail_3_freq = response.data.data[5].freq
        this.compare2_attribute_search_detail_3_rate = response.data.data[5].rate
        this.compare2_attribute_search_detail_3_rate = this.compare2_attribute_search_detail_3_rate +"%"
        this.compare2_attribute_search_detail_4_nm = response.data.data[6].cdjDetails
        this.compare2_attribute_search_detail_4_freq = response.data.data[6].freq
        this.compare2_attribute_search_detail_4_rate = response.data.data[6].rate
        this.compare2_attribute_search_detail_4_rate = this.compare2_attribute_search_detail_4_rate +"%"
        this.compare2_attribute_search_detail_5_nm = response.data.data[7].cdjDetails
        this.compare2_attribute_search_detail_5_freq = response.data.data[7].freq
        this.compare2_attribute_search_detail_5_rate = response.data.data[7].rate
        this.compare2_attribute_search_detail_5_rate = this.compare2_attribute_search_detail_5_rate +"%"

        this.compare2_buy_manage_detail_1_nm = response.data.data[8].cdjDetails
        this.compare2_buy_manage_detail_1_freq = response.data.data[8].freq
        this.compare2_buy_manage_detail_1_rate = response.data.data[8].rate
        this.compare2_buy_manage_detail_1_rate = this.compare2_buy_manage_detail_1_rate +"%"
        this.compare2_buy_manage_detail_2_nm = response.data.data[9].cdjDetails
        this.compare2_buy_manage_detail_2_freq = response.data.data[9].freq
        this.compare2_buy_manage_detail_2_rate = response.data.data[9].rate
        this.compare2_buy_manage_detail_2_rate = this.compare2_buy_manage_detail_2_rate + "%"

        var max_rate = 0

        for(const item of response.data.data){
          if(item.rate > max_rate)
            max_rate = item.rate
        }

        // stackedChart
        this.loadCompareStackedRight(response.data.data, max_rate);
      }
    },

    async loadCompareStackedRight(cdjTableData, maxRate){
      console.log('-- loadCompareStackedRight --')

      this.compareStackChartData2 = []

      // stacked chart category setting
      this.compareStackChartCategory2 = []

      for(const item of cdjTableData)
        this.compareStackChartCategory2.push(item.cdjDetails)

      var startDate = moment(this.form2.monthSelect[0]).format("YYYY-MM")
      var endDate = moment(this.form2.monthSelect[1]).add(1, 'month').format("YYYY-MM")

      var firstClassList = []

      for(const item of this.compareFirstClasses)
        firstClassList.push(item)

      var sel_Middle = this.compareMiddleClass != null ? this.compareMiddleClass : null; 

      if (sel_Middle == '중분류 없음')
        sel_Middle = '기타'

      var brandList = []

      if(this.compareSelectedBrand2 != '' && this.compareSelectedBrand2 != null )      
        brandList.push(this.compareSelectedBrand2)

      const response = await CisInsightService.getInsightDataStacked({
        startDate : startDate,
        endDate : endDate,
        ctgSq : this.$store.getters.getSelectedCategory,
        brandList : brandList,
        firstClassList : firstClassList,
        selMiddle: sel_Middle, 
        cdjDetail1 : this.compareStackChartCategory2[0],
        cdjDetail2 : this.compareStackChartCategory2[1],
        cdjDetail3 : this.compareStackChartCategory2[2],
        cdjDetail4 : this.compareStackChartCategory2[3],
        cdjDetail5 : this.compareStackChartCategory2[4],
        cdjDetail6 : this.compareStackChartCategory2[5],
        cdjDetail7 : this.compareStackChartCategory2[6],
        cdjDetail8 : this.compareStackChartCategory2[7],
        cdjDetail9 : this.compareStackChartCategory2[8],
        cdjDetail10 : this.compareStackChartCategory2[9]
      }, source);

      if (response && response.status === 200) {
        console.log('-- 중단 Stacked data --')
        console.log(response)

        // min height 설정
        var minHeight = Math.round((100/9)*100)/100

        // stacked chart update
        this.compareStackChartData2 = []
        var stackDatas = []

        for(const item of response.data.data) {
          var heights_pre = item.rate.split(',')
          var heights = []

          for (const height of heights_pre){
            if (height == 0)
              heights.push(0)
            else if (height > minHeight)
              heights.push(minHeight)
            else
              heights.push(minHeight)            
          }

          var keywords = item.keyword.split(',')
          var freqs = item.freq.split(',')
          var rates = item.rate.split(',')

          stackDatas = []
          stackDatas.push(keywords)
          stackDatas.push(freqs)
          stackDatas.push(rates)
          stackDatas.push(heights)
          this.compareStackChartData2.push(stackDatas)
        }
        
        if(document.getElementById('compareLoadingStack2')){
          document.getElementById('compareLoadingStack2').style.visibility = "hidden";
        }
        if(document.getElementById('compareStackChart2')){
          document.getElementById('compareStackChart2').style.visibility = "visible";
        }
      }
    },


    

    abort(isReset, message) {
      // cancel the request
      source.cancel(message);

      if (isReset)
        source = cancelToken.source();
    },
    
  },
  created() {
    console.log('compare modal created')
    

  },
  computed: {


  },
  mounted() {
    console.log('compare modal mounted')

  }
};
</script>

<style>

#compare-modal > div {
  max-width: 98%;
}

.modal-lg,
.modal-xl {
  width: 100%;
  height: 100%;
}

#compare-modal___BV_modal_title_
{
    font-family: "NanumBarunGothic", Arial, sans-serif !important;
    font-weight: bold;
}

.select-brand .vs__dropdown-menu
{
  padding: 0px 0px 0px 0px;
}

#compareCDJCol0 .apexcharts-canvas .apexcharts-text, #compareCDJCol0 .apexcharts-canvas .apexcharts-tooltip-text, #compareCDJCol0 .apexcharts-canvas .apexcharts-datalabel-label, #compareCDJCol0 .apexcharts-canvas .apexcharts-datalabel,
#compareCDJCol1 .apexcharts-canvas .apexcharts-text, #compareCDJCol1 .apexcharts-canvas .apexcharts-tooltip-text, #compareCDJCol1 .apexcharts-canvas .apexcharts-datalabel-label, #compareCDJCol1 .apexcharts-canvas .apexcharts-datalabel,
#compareCDJCol2 .apexcharts-canvas .apexcharts-text, #compareCDJCol2 .apexcharts-canvas .apexcharts-tooltip-text, #compareCDJCol2 .apexcharts-canvas .apexcharts-datalabel-label, #compareCDJCol2 .apexcharts-canvas .apexcharts-datalabel
{
  font-family: "NanumBarunGothic", Arial, sans-serif !important;
  filter: none;
}

/* // table css ///////////////////////////////////////// */
.compareCdjTable0,
.compareCdjTable1,
.compareCdjTable2
{
  width: 100.3%;
  border: 2px solid;
  border-color: #989898;
  text-align: center;
  color: #3E3C45;
}

.compareCdjTable0 th, 
.compareCdjTable1 th, 
.compareCdjTable2 th, 
.compareCdjTable0 td,
.compareCdjTable1 td,
.compareCdjTable2 td
{
  border: 1px solid;
  border-color: #989898;
  padding: 0.5rem 0.5rem;
}

.compareCdjTable0 td,
.compareCdjTable1 td,
.compareCdjTable2 td
{
  width: 9%;
}

.compareCdjTable0_1Tr_1Th,
.compareCdjTable0_2Tr_1Td,
.compareCdjTable0_2Tr_2Td,
.compareCdjTable0_2Tr_3Td,
.compareCdjTable0_3Tr_1Td,
.compareCdjTable0_3Tr_2Td,
.compareCdjTable0_3Tr_3Td,
.compareCdjTable1_1Tr_1Th,
.compareCdjTable1_2Tr_1Td,
.compareCdjTable1_2Tr_2Td,
.compareCdjTable1_2Tr_3Td,
.compareCdjTable1_3Tr_1Td,
.compareCdjTable1_3Tr_2Td,
.compareCdjTable1_3Tr_3Td,
.compareCdjTable2_1Tr_1Th,
.compareCdjTable2_2Tr_1Td,
.compareCdjTable2_2Tr_2Td,
.compareCdjTable2_2Tr_3Td,
.compareCdjTable2_3Tr_1Td,
.compareCdjTable2_3Tr_2Td,
.compareCdjTable2_3Tr_3Td
{
  background-color: #F2F2F2;
  cursor: pointer;
}

.compareCdjTable0_2Tr_1Td,
.compareCdjTable0_2Tr_2Td,
.compareCdjTable0_2Tr_3Td,
.compareCdjTable0_3Tr_1Td,
.compareCdjTable0_3Tr_2Td,
.compareCdjTable0_3Tr_3Td,
.compareCdjTable1_2Tr_1Td,
.compareCdjTable1_2Tr_2Td,
.compareCdjTable1_2Tr_3Td,
.compareCdjTable1_3Tr_1Td,
.compareCdjTable1_3Tr_2Td,
.compareCdjTable1_3Tr_3Td,
.compareCdjTable2_2Tr_1Td,
.compareCdjTable2_2Tr_2Td,
.compareCdjTable2_2Tr_3Td,
.compareCdjTable2_3Tr_1Td,
.compareCdjTable2_3Tr_2Td,
.compareCdjTable2_3Tr_3Td
{
  font-size: 10px;
  font-weight: 600;
}

.compareCdjTable0_1Tr_2Th,
.compareCdjTable0_2Tr_4Td,
.compareCdjTable0_2Tr_5Td,
.compareCdjTable0_2Tr_6Td,
.compareCdjTable0_2Tr_7Td,
.compareCdjTable0_2Tr_8Td,
.compareCdjTable0_3Tr_4Td,
.compareCdjTable0_3Tr_5Td,
.compareCdjTable0_3Tr_6Td,
.compareCdjTable0_3Tr_7Td,
.compareCdjTable0_3Tr_8Td,
.compareCdjTable1_1Tr_2Th,
.compareCdjTable1_2Tr_4Td,
.compareCdjTable1_2Tr_5Td,
.compareCdjTable1_2Tr_6Td,
.compareCdjTable1_2Tr_7Td,
.compareCdjTable1_2Tr_8Td,
.compareCdjTable1_3Tr_4Td,
.compareCdjTable1_3Tr_5Td,
.compareCdjTable1_3Tr_6Td,
.compareCdjTable1_3Tr_7Td,
.compareCdjTable1_3Tr_8Td,
.compareCdjTable2_1Tr_2Th,
.compareCdjTable2_2Tr_4Td,
.compareCdjTable2_2Tr_5Td,
.compareCdjTable2_2Tr_6Td,
.compareCdjTable2_2Tr_7Td,
.compareCdjTable2_2Tr_8Td,
.compareCdjTable2_3Tr_4Td,
.compareCdjTable2_3Tr_5Td,
.compareCdjTable2_3Tr_6Td,
.compareCdjTable2_3Tr_7Td,
.compareCdjTable2_3Tr_8Td
{
  background-color: #F2F2F2;
  cursor: pointer;
}

.compareCdjTable0_2Tr_4Td,
.compareCdjTable0_2Tr_5Td,
.compareCdjTable0_2Tr_6Td,
.compareCdjTable0_2Tr_7Td,
.compareCdjTable0_2Tr_8Td,
.compareCdjTable0_3Tr_4Td,
.compareCdjTable0_3Tr_5Td,
.compareCdjTable0_3Tr_6Td,
.compareCdjTable0_3Tr_7Td,
.compareCdjTable0_3Tr_8Td,
.compareCdjTable1_2Tr_4Td,
.compareCdjTable1_2Tr_5Td,
.compareCdjTable1_2Tr_6Td,
.compareCdjTable1_2Tr_7Td,
.compareCdjTable1_2Tr_8Td,
.compareCdjTable1_3Tr_4Td,
.compareCdjTable1_3Tr_5Td,
.compareCdjTable1_3Tr_6Td,
.compareCdjTable1_3Tr_7Td,
.compareCdjTable1_3Tr_8Td,
.compareCdjTable2_2Tr_4Td,
.compareCdjTable2_2Tr_5Td,
.compareCdjTable2_2Tr_6Td,
.compareCdjTable2_2Tr_7Td,
.compareCdjTable2_2Tr_8Td,
.compareCdjTable2_3Tr_4Td,
.compareCdjTable2_3Tr_5Td,
.compareCdjTable2_3Tr_6Td,
.compareCdjTable2_3Tr_7Td,
.compareCdjTable2_3Tr_8Td
{
  font-size: 10px;
  font-weight: 600;
}

.compareCdjTable0_1Tr_3Th,
.compareCdjTable0_2Tr_9Td,
.compareCdjTable0_2Tr_10Td,
.compareCdjTable0_3Tr_9Td,
.compareCdjTable0_3Tr_10Td,
.compareCdjTable1_1Tr_3Th,
.compareCdjTable1_2Tr_9Td,
.compareCdjTable1_2Tr_10Td,
.compareCdjTable1_3Tr_9Td,
.compareCdjTable1_3Tr_10Td,
.compareCdjTable2_1Tr_3Th,
.compareCdjTable2_2Tr_9Td,
.compareCdjTable2_2Tr_10Td,
.compareCdjTable2_3Tr_9Td,
.compareCdjTable2_3Tr_10Td
{
  background-color: #F2F2F2;
  cursor: pointer;
}

.compareCdjTable0_2Tr_9Td,
.compareCdjTable0_2Tr_10Td,
.compareCdjTable0_3Tr_9Td,
.compareCdjTable0_3Tr_10Td,
.compareCdjTable1_2Tr_9Td,
.compareCdjTable1_2Tr_10Td,
.compareCdjTable1_3Tr_9Td,
.compareCdjTable1_3Tr_10Td,
.compareCdjTable2_2Tr_9Td,
.compareCdjTable2_2Tr_10Td,
.compareCdjTable2_3Tr_9Td,
.compareCdjTable2_3Tr_10Td
{
  font-size: 10px;
  font-weight: 700;
}

.compareCdjTable0_1Tr_4Th,
.compareCdjTable0_3Tr_11Td,
.compareCdjTable1_1Tr_4Th,
.compareCdjTable1_3Tr_11Td,
.compareCdjTable2_1Tr_4Th,
.compareCdjTable2_3Tr_11Td
{
  background-color: #F2F2F2;
  cursor: pointer;
}

/* ////////////////////////////////////////////////////// */




</style>